/* eslint-disable*/
import { useEffect, useState, useRef, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faSortUp,
  faSortDown,
  faSort,
  faIdCard,
  faRefresh,
  faEnvelope,
  faMobileAlt,
  faEllipsisVertical,
  faFlag,
  faHeadset,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import axios from "axios";
import { API_URL } from "../config.js";
import { PermissionWrapper, hasPermission } from "../helpers/permission.js";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../components/toast.jsx";
import "./subscribe.css";
import bluetick from "../assets/img/bluetick.png";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { subMonths, startOfMonth } from "date-fns";
import Swal from "sweetalert2";
import MultiSelectDropdown from "./MultiSelectDropdown";
import CampaignModal from "./CampaignModal";
import AICampaignModal from "./AICampaignModal";
import SarvamCampaignModal from "./SarvamCampaignModal";
import AIVoiceCallModal from "./AIVoiceCallModal";
import CampaignExportModal from "./CampaignExportModal";
import usePersistedState from "./usePersistedState.jsx";
import BroadcastModal from "./Broadcast";
import IncomingCallReport from "./IncomingCallReport";
import Select from "react-select";
import useDoubleScroll from "../helpers/useDoubleScroll";


// AI Tag filter options
const aiTagOptions = [
  { pick_name: "Hot", name: "Hot" },
  { pick_name: "Warm", name: "Warm" },
  { pick_name: "Value", name: "Value" },
  { pick_name: "Escalate", name: "Escalate" },
];

// Add FieldPermissionWrapper component for field-level permissions
const FieldPermissionWrapper = ({ field, children }) => {
  const hasFieldViewPermission = hasPermission(field, "view");
  return hasFieldViewPermission ? children : null;
};

// Helper function to parse single range string into min and max values
const parseNumericRange = (value) => {
  if (!value || typeof value !== "string") return { min: undefined, max: undefined };
  const trimmed = value.trim();
  if (!trimmed) return { min: undefined, max: undefined };

  // Match range like "100-200", "100 - 200", "100 to 200"
  const rangeMatch = trimmed.match(/^(\d+(?:\.\d+)?)\s*(?:-|to)\s*(\d+(?:\.\d+)?)$/i);
  if (rangeMatch) {
    return { min: rangeMatch[1], max: rangeMatch[2] };
  }

  // Match ">=100", ">100", "100+"
  const gteMatch = trimmed.match(/^(?:>=?|>)\s*(\d+(?:\.\d+)?)$/) || trimmed.match(/^(\d+(?:\.\d+)?)\+$/);
  if (gteMatch) {
    return { min: gteMatch[1], max: undefined };
  }

  // Match "<=200", "<200"
  const lteMatch = trimmed.match(/^(?:<=?|<)\s*(\d+(?:\.\d+)?)$/);
  if (lteMatch) {
    return { min: undefined, max: lteMatch[1] };
  }

  // Single number "100": set both min and max for exact match
  const singleMatch = trimmed.match(/^(\d+(?:\.\d+)?)$/);
  if (singleMatch) {
    return { min: singleMatch[1], max: singleMatch[1] };
  }

  return { min: undefined, max: undefined };
};

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "30px",
    height: "30px",
    fontSize: "12px",
    borderRadius: "0",
    border: "1px solid #ced4da",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #ced4da",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 6px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "12px",
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "4px 10px",
  }),
  clearIndicator: () => ({
    display: "none",
  }),
};


const Subscriber = () => {
  const token = localStorage.getItem("authToken");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRendering, setIsRendering] = useState(false);
  const tableRenderedRef = useRef(false);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);
  const actionMenuRef = useRef(null);
  const prevMonthStart = startOfMonth(subMonths(new Date(), 1));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeFilter = queryParams.get("filter");
  if (activeFilter === "IncomingCallReport") {
    return <IncomingCallReport />;
  }
  const [joinDateFilter, setJoinDateFilter] = usePersistedState(
    "subscriber_joinDateFilter",
    [null, null]
  );
  const [uidFilter, setUidFilter] = usePersistedState(
    "subscriber_uidFilter",
    ""
  );
  const [leadSourceFilter, setLeadSourceFilter] = usePersistedState(
    "subscriber_leadSourceFilter",
    ""
  );
  const [nameFilter, setNameFilter] = usePersistedState(
    "subscriber_nameFilter",
    ""
  );
  const [mobileFilter, setMobileFilter] = usePersistedState(
    "subscriber_mobileFilter",
    ""
  );
  const [altMobileFilter, setAltMobileFilter] = usePersistedState(
    "subscriber_altMobileFilter",
    ""
  );
  const [emailFilter, setEmailFilter] = usePersistedState(
    "subscriber_emailFilter",
    ""
  );
  const [aiTagFilter, setAiTagFilter] = usePersistedState(
    "subscriber_aiTagFilter",
    []
  );
  const [stateFilter, setStateFilter] = usePersistedState(
    "subscriber_stateFilter",
    ""
  );
  const [invCapitalFilter, setInvCapitalFilter] = usePersistedState(
    "subscriber_invCapitalFilter",
    ""
  );
  const [leadStatusFilter, setLeadStatusFilter] = usePersistedState(
    "subscriber_leadStatusFilter",
    []
  );
  const [expInMarketFilter, setExpInMarketFilter] = usePersistedState(
    "subscriber_expInMarketFilter",
    ""
  );
  const [investmentStatusFilter, setInvestmentStatusFilter] = usePersistedState(
    "subscriber_investmentStatusFilter",
    ""
  );
  const [convertibleFilter, setConvertibleFilter] = usePersistedState(
    "subscriber_convertibleFilter",
    ""
  );
  const [recentContactedDateFilter, setRecentContactedDateFilter] =
    usePersistedState("subscriber_recentContactedDateFilter", [null, null]);
  const [followUpDateFilter, setFollowUpDateFilter] = usePersistedState(
    "subscriber_followUpDateFilter",
    [null, null]
  );
  const [languageFilter, setLanguageFilter] = usePersistedState(
    "subscriber_languageFilter",
    ""
  );
  const [clientStatusFilter, setClientStatusFilter] = usePersistedState(
    "subscriber_clientStatusFilter",
    []
  );
  const [subscribedDateFilter, setSubscribedDateFilter] = usePersistedState(
    "subscriber_subscribedDateFilter",
    [null, null]
  );
  const [subscriberStatusFilter, setSubscriberStatusFilter] = usePersistedState(
    "subscriber_subscriberStatusFilter",
    []
  );
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [assignedToFilter, setAssignedToFilter] = usePersistedState(
    "subscriber_assignedToFilter",
    ""
  );
  const [updatedOnDateFilter, setUpdatedOnDateFilter] = usePersistedState(
    "subscriber_updatedOnDateFilter",
    [null, null]
  );
  const [updatedByFilter, setUpdatedByFilter] = usePersistedState(
    "subscriber_updatedByFilter",
    ""
  );
  const [deviceIdFilter, setDeviceIdFilter] = usePersistedState(
    "subscriber_deviceIdFilter",
    ""
  );
  const [utmSourceFilter, setUtmSourceFilter] = usePersistedState(
    "subscriber_utmSourceFilter",
    ""
  );
  const [utmMediumFilter, setUtmMediumFilter] = usePersistedState(
    "subscriber_utmMediumFilter",
    ""
  );
  const [utmCampaignFilter, setUtmCampaignFilter] = usePersistedState(
    "subscriber_utmCampaignFilter",
    ""
  );
  const [utmContentFilter, setUtmContentFilter] = usePersistedState(
    "subscriber_utmContentFilter",
    ""
  );
  const [utmTermFilter, setUtmTermFilter] = usePersistedState(
    "subscriber_utmTermFilter",
    ""
  );
  const [isEmailFilterEnabled, setIsEmailFilterEnabled] = useState(false);
  const [emailFilterState, setEmailFilterState] = usePersistedState(
    "subscriber_emailFilterState",
    0
  );
  const [page, setPage] = useState(1);
  const [tempPage, setTempPage] = useState(page);

  const [hasMoreData, setHasMoreData] = useState(true); // Flag to check if more data is available
  const [sortField, setSortField] = usePersistedState(
    "subscriber_sortField",
    ""
  );
  const [sortOrder, setSortOrder] = usePersistedState(
    "subscriber_sortOrder",
    ""
  );
  const [tradeFilter, setTradeFilter] = usePersistedState(
    "subscriber_tradeFilter",
    0
  );
  const [streetfolioFilter, setStreetfolioFilter] = usePersistedState(
    "subscriber_streetfolioFilter",
    0
  );
  const [categoryFilter, setCategoryFilter] = usePersistedState(
    "subscriber_categoryFilter",
    ""
  );
  const [tradeCreatedOnFilter, setTradeCreatedOnFilter] = usePersistedState(
    "subscriber_tradeCreatedOnFilter",
    [null, null]
  );
  const [folioCreatedOnFilter, setFolioCreatedOnFilter] = usePersistedState(
    "subscriber_folioCreatedOnFilter",
    [null, null]
  );
  const [assignedToFolioFilter, setAssignedToFolioFilter] = usePersistedState(
    "subscriber_assignedToFolioFilter",
    ""
  );
  const [assignedToResearchFilter, setAssignedToResearchFilter] = usePersistedState(
    "subscriber_assignedToResearchFilter",
    ""
  );
  const [askfpsFilter, setAskfpsFilter] = usePersistedState(
    "subscriber_askfpsFilter",
    ""
  );
  const [leadEnFilter, setLeadEnFilter] = usePersistedState(
    "subscriber_leadEnFilter",
    ""
  );
  const [inFolioFilter, setInFolioFilter] = usePersistedState(
    "subscriber_inFolioFilter",
    ""
  );
  const [subscriptionAmountFilter, setSubscriptionAmountFilter] = usePersistedState(
    "subscriber_subscriptionAmountFilter",
    ""
  );
  const [firstAmountFilter, setFirstAmountFilter] = usePersistedState(
    "subscriber_firstAmountFilter",
    ""
  );

  // Ensure aiTagFilter is always an array (migration from previous string state)
  useEffect(() => {
    if (typeof aiTagFilter === "string") {
      setAiTagFilter(
        aiTagFilter.trim()
          ? aiTagFilter
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          : []
      );
    }
  }, [aiTagFilter]);
  const [dropdownOptions, setDropdownOptions] = useState({
    leadSourceList: [],
    languageList: [],
    leadStatusList: [],
    invCapitalList: [],
    expInMarketList: [],
    investmentsList: [],
    convertibleList: [],
    clientStatusList: [],
    statusList: [],
    assignedUserList: [],
    assignedResearchUserList: [],
    fullUserList: [],
    stateList: [],
    utmSourceList: [],
    utmMediumList: [],
    utmCampaignList: [],
    utmContentList: [],
    utmTermList: [],
    subscriberStatusList: [],
    dematBrokersList: [],
    riskLevelList: [],
    priceExpectedList: [],
    interestSegmentsList: [],
    reasonNotInterestedList: [],
    updatedByUserList: [],
    serviceList: [],
    templatePushNotificationList: [],
    templateSmsList: [],
    sourceList: [],
  });
  const [isBulkEditModalOpen, setIsBulkEditModalOpen] = useState(false);
  const [bulkEditData, setBulkEditData] = useState({
    lead_source: "",
    state: "",
    occupation: "",
    language: "",
    exp_in_market: "",
    inv_capital: "",
    risk_level: "",
    lead_status: "",
    assignedto: "",
    reason_not_interested: "",
    lead_en: "",
  });
  const [selectedSubscribers, setSelectedSubscribers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredCount, setFilteredCount] = useState(0);
  const navigate = useNavigate();

  const [checkingAll, setCheckingAll] = useState(false);
  const [showSelectAllButton, setShowSelectAllButton] = useState(false);
  const [isModalOpenBulkImport, setIsModalOpenBulkImport] = useState(false);
  const [isModalOpenSendEmail, setIsModalOpenSendEmail] = useState(false);
  const [emailData, setEmailData] = useState({
    emailtemp: "",
    subject: "",
    message: "",
    file: null,
  });
  const [templateList, setTemplateList] = useState([]);
  const [isImporting, setIsImporting] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [mobileSearchResult, setMobileSearchResult] = useState(null);
  const [isSearchingMobile, setIsSearchingMobile] = useState(false);
  const [mobileSearchInput, setMobileSearchInput] = useState("");
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [isAICampaignModalOpen, setIsAICampaignModalOpen] = useState(false);
  const [isSarvamCampaignModalOpen, setIsSarvamCampaignModalOpen] = useState(false);
  const [isAiVoiceCallModalOpen, setIsAiVoiceCallModalOpen] = useState(false);
  const [selectedSubscriberForAiCall, setSelectedSubscriberForAiCall] = useState(null);
  const [isBroadcastModalOpen, setIsBroadcastModalOpen] = useState(false);
  const [campaignLoading, setCampaignLoading] = useState(false);
  const [isCampaignExportOpen, setIsCampaignExportOpen] = useState(false);
  const shouldShowSubscriberId = hasPermission("subscriber_id", "view");
  const shouldShowMobileNo = hasPermission("subscriber_mobileno", "view");
  const [totalSubscriptionAmount, setTotalSubscriptionAmount] = useState(0);
  const [totalFirstAmount, setTotalFirstAmount] = useState(0);

  // Footer column spans must mirror the permission-wrapped columns of the table
  // so the totals line up under "Subscription Amount" and "First Amount".
  const countVisible = (fields) =>
    fields.filter((field) => hasPermission(field, "view")).length;
  const showClientStatusColumns = hasPermission("subscriber_client_status", "view");
  const footerLeadingColSpan =
    4 + // checkbox, created time, trades, recent contacted (always shown)
    countVisible([
      "subscriber_id",
      "subscriber_lead_source",
      "subscriber_fullname",
      "subscriber_mobileno",
      "subscriber_otherphone",
      "subscriber_email",
      "subscriber_ai_tag",
      "subscriber_state",
      "service_category",
      "subscriber_trade_created_on",
      "subscriber_in_folio",
      "subscriber_folio_created_on",
      "subscriber_in_folio",
      "subscriber_inv_capital",
      "subscriber_lead_status",
      "subscriber_exp_in_market",
      "subscriber_investments",
      "subscriber_convertible",
      "subscriber_next_followup",
      "subscriber_language",
    ]) +
    (showClientStatusColumns ? 4 : 0); // client status, subscribed on, condays, active days
  const footerTrailingColSpan =
    1 + // device id (always shown)
    countVisible([
      "subscriber_assignedtomenu",
      "subscriber_assigned_to_research",
      "subscriber_askfps",
      "subscriber_lead_en",
      "subscriber_assignedto_folio",
      "subscriber_modified_time",
      "subscriber_updatedby",
      "subscriber_utmsource",
      "subscriber_utmmedium",
      "subscriber_utmcampaign",
      "subscriber_utmcontent",
      "subscriber_utmterm",
    ]);
  const canViewAmountTotals = hasPermission("subscription_amount", "view");
  const [dropdownLoading, setDropdownLoading] = useState(true);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSearch = () => {
    setPage(1);
    setSearchTrigger((prev) => prev + 1);
  };
  const getFirstStickyColumnClass = () => {
    // if (shouldShowSubscriberId) {
    //   return "sticky-subid"; // Subscriber ID is visible, it's first
    // } else if (shouldShowMobileNo) {
    //   return "sticky-first"; // Mobile No becomes first when Subscriber ID is hidden
    // }
    return ""; // No sticky column if neither is visible
  };

  const getMobileColumnClass = () => {
    // if (shouldShowSubscriberId) {
    //   return "sticky-mobile"; // Mobile is second when Subscriber ID is visible
    // } else if (shouldShowMobileNo) {
    //   return "sticky-first"; // Mobile becomes first when Subscriber ID is hidden
    // }
    return "";
  };
  const clearAllFilters = () => {
    setJoinDateFilter([null, null]);
    setUidFilter("");
    setLeadSourceFilter("");
    setNameFilter("");
    setMobileFilter("");
    setAltMobileFilter("");
    setEmailFilter("");
    setAiTagFilter([]);
    setStateFilter("");
    setInvCapitalFilter("");
    setLeadStatusFilter([]);
    setExpInMarketFilter("");
    setInvestmentStatusFilter("");
    setConvertibleFilter("");
    setRecentContactedDateFilter([null, null]);
    setFollowUpDateFilter([null, null]);
    setLanguageFilter("");
    setClientStatusFilter([]);
    setSubscribedDateFilter([null, null]);
    setSubscriberStatusFilter([]);
    setAssignedToFilter("");
    setUpdatedOnDateFilter([null, null]);
    setUpdatedByFilter("");
    setDeviceIdFilter("");
    setUtmSourceFilter("");
    setUtmMediumFilter("");
    setUtmCampaignFilter("");
    setUtmContentFilter("");
    setUtmTermFilter("");
    setEmailFilterState(0);
    setTradeFilter(0);
    setStreetfolioFilter(0);
    setCategoryFilter("");
    setTradeCreatedOnFilter([null, null]);
    setFolioCreatedOnFilter([null, null]);
    setAssignedToFolioFilter("");
    setAssignedToResearchFilter("");
    setAskfpsFilter("");
    setInFolioFilter("");
    setSubscriptionAmountFilter("");
    setFirstAmountFilter("");
    setSortField("");
    setSortOrder("");
    setPage(1);

    // Clear from localStorage
    // const keys = Object.keys(localStorage).filter(key => key.startsWith('subscriber_'));
    // keys.forEach(key => localStorage.removeItem(key));

    // showToast.success("All filters cleared");
    fetchUsers(1);
  };

  const handleBulkImportSubmit = async (e) => {
    e.preventDefault();

    if (!importFile) {
      showToast.warning("Please select a file to import");
      return;
    }

    setIsImporting(true);
    setMessage("");

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", importFile);

      const response = await axios.post(
        `${API_URL}subscriber/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success || response.status === 201) {
        setMessage(response.data.message || "Import completed successfully");
        setMessageType("success");
        showToast.success("Subscribers imported successfully");

        // Refresh the subscriber list after a short delay
        setTimeout(() => {
          setIsModalOpenBulkImport(false);
          fetchUsers();
        }, 2000);
      } else {
        setMessage(response.data.message || "Import failed");
        setMessageType("error");
        showToast.error(response.data.message || "Import failed");
      }
    } catch (error) {
      console.error("Import error:", error);
      let errorMessage = "An error occurred during import";

      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;

        // Handle validation errors from server
        if (error.response.data.errors) {
          errorMessage +=
            ": " + Object.values(error.response.data.errors).join(", ");
        }
      }

      setMessage(errorMessage);
      setMessageType("error");
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
      setIsImporting(false);
    }
  };

  const fetchEmailTemplates = async () => {
    try {
      const response = await axios.get(
        `${API_URL}settings/template/email/list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Check if response.data.data exists and is an array
      if (response.data.success && Array.isArray(response.data.data)) {
        setTemplateList(response.data.data);
      } else {
        setTemplateList([]); // Set to empty array if no data
      }
    } catch (error) {
      console.error("Error fetching templates", error);
      setTemplateList([]); // Set to empty array on error
    }
  };

  const fetchSmsTemplate = async () => {
    try {
      setIsLoadingSmsTemplate(true);
      const response = await axios.get(`${API_URL}subscriber/get-template`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data && response.data.success && response.data.data) {
        const { templateSmsList } = response.data.data;

        // Update dropdown options with SMS templates
        setDropdownOptions((prevOptions) => ({
          ...prevOptions,
          templateSmsList: templateSmsList || [],
        }));

        // Set the first template as default if available
        if (templateSmsList && templateSmsList.length > 0) {
          const firstTemplate = templateSmsList[0];
          setSmsTemplateData({
            template: firstTemplate,
          });

          // Auto-populate the SMS form with template data
          setSendSmsData((prevData) => ({
            ...prevData,
            pushTemplate: firstTemplate.id.toString(),
            message: firstTemplate.message || "",
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching SMS template:", error);
      showToast.error("Failed to load SMS template");
    } finally {
      setIsLoadingSmsTemplate(false);
    }
  };

  const handleTemplateChange = async (templateId) => {
    if (!templateId) {
      setEmailData((prev) => ({
        ...prev,
        emailtemp: "",
        subject: "",
        message: "",
      }));
      return;
    }

    try {
      const response = await axios.get(
        `${API_URL}settings/template/email/${templateId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        const template = response.data.data;
        setEmailData((prev) => ({
          ...prev,
          emailtemp: templateId,
          subject: template.subject || "",
          message: template.message || "",
        }));
      }
    } catch (error) {
      console.error("Error loading template", error);
      showToast.error("Failed to load template");
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!emailData.subject?.trim() || !emailData.message?.trim()) {
      showToast.warning("Subject and message are required");
      return;
    }

    try {
      setLoading(true);

      // Determine filters if checkingAll is true
      const filterParams = checkingAll
        ? hasAnyFilter()
          ? getCurrentFilterParams()
          : {}
        : {};

      // Prepare form data
      const formData = new FormData();

      // IDs of selected subscribers or empty if checkingAll
      formData.append(
        "selectedIds",
        checkingAll ? "" : selectedSubscribers.join(",")
      );

      // Filters (stringified JSON)
      formData.append("filters", JSON.stringify(filterParams));

      // Template ID (from email template selection)
      formData.append("templateId", emailData.emailtemp || "");

      // Email-specific fields
      formData.append("subject", emailData.subject);
      formData.append("emailmessage", emailData.message);

      // Optional attachment
      if (emailData.file) {
        formData.append("imageUrl", emailData.file);
      }

      // API request
      const response = await axios.post(
        `${API_URL}subscriber/email-bulk-popup?checkingAll=${checkingAll}`, // Pass checkingAll in query
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        showToast.success(response.data.message || "Email sent successfully!");
        setIsModalOpenSendEmail(false);

        // Reset form
        setEmailData({
          emailtemp: "",
          subject: "",
          message: "",
          file: null,
        });
        setSelectedSubscribers([]);
        fetchUsers();
      } else {
        showToast.error(response.data.message || "Failed to send email");
      }
    } catch (error) {
      console.error("Email send error:", error);
      showToast.error(error.response?.data?.message || "Error sending email");
    } finally {
      setLoading(false);
    }
  };

  const toggleCheckingAll = () => {
    const newCheckingAll = !checkingAll;
    setCheckingAll(newCheckingAll);

    if (newCheckingAll) {
      // When selecting all records, we keep the currently selected ones
      // The backend will handle selecting all records based on filters
      setShowSelectAllButton(false);
    } else {
      // When deselecting all records, clear the selection
      setSelectedSubscribers([]);
      setShowSelectAllButton(false);
    }
  };

  const sortBox = (field) => {
    if (sortField === field) {
      const newOrder = sortOrder === "asc" ? "desc" : "asc";
      setSortOrder(newOrder);
      fetchUsers(1); // refetch data on toggle
    } else {
      setSortField(field);
      setSortOrder("asc");
      fetchUsers(1); // refetch data on new field
    }
  };

  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? faSortUp : faSortDown;
    }
    return faSort; // default icon for inactive columns
  };



  const tableWrapperRef = useRef(null);
  const tableContainerRef = useRef(null);
  const topScrollRef = useDoubleScroll(tableContainerRef);
  const limit = 100;

  // useEffect(() => {
  //   // if (!activeFilter) {
  //   //   return; // do not modify filters unless a quick filter is active
  //   // }

  //   const today = moment().startOf("day").toDate();
  //   const sevenDaysAgo = moment().subtract(7, "days").startOf("day").toDate();
  //   const nextYearToday = moment().add(1, "year").startOf("day").toDate();

  //   const filterConfig = {
  //     New: { lead: "New" },
  //     RecentSubscriber: { recentContacted: [today, today] },
  //     ContactToday: { followUp: [today, today] },
  //     FutureContact: { lead: "Follow Up", followUp: [today, nextYearToday] },
  //     NotInterested: { lead: "Not Interested" },
  //     NoResponse: { lead: "No Response" },
  //     Prospect: { lead: "Prospect" },
  //     Junk: { lead: "Junk" },
  //     Subscribed: { client: "Subscribed" },
  //     IncomingCallReport: { lead: "Incoming Call" },
  //     Read: { isRead: 1 }, // isRead: 1 for read messages
  //     Unread: { isRead: 0 }, // isRead: 0 for unread messages
  //     Subscribers: {} // Clear all filters for main Subscribers page
  //   };

  //   const config = filterConfig[activeFilter] || {};

  //   // Clear all quick-filter-driven fields first
  //   const clearQuickFilters = () => {
  //     setLeadStatusFilter([]);
  //     setClientStatusFilter([]);
  //     setFollowUpDateFilter([null, null]);
  //     setRecentContactedDateFilter([null, null]);
  //   };

  //   setPage(1);

  //   // If no active filter or it's the main Subscribers page, clear all quick filters
  //   if (!activeFilter || activeFilter === "Subscribers") {
  //     clearQuickFilters();
  //     return;
  //   }

  //   // Clear previous quick filters before applying new ones
  //   clearQuickFilters();

  //   const matchedLeadStatusItem = dropdownOptions.leadStatusList.find(
  //     (item) => item.pick_name === config.lead
  //   );
  //   const matchedClientStatusItem = dropdownOptions.clientStatusList.find(
  //     (item) => item.pick_name === config.client
  //   );

  //   if (matchedLeadStatusItem) {
  //     setLeadStatusFilter([matchedLeadStatusItem.pick_name]);
  //   }
  //   if (matchedClientStatusItem) {
  //     setClientStatusFilter([matchedClientStatusItem.pick_name]);
  //   }
  //   if (config.followUp) {
  //     setFollowUpDateFilter(config.followUp);
  //   }
  //   if (config.recentContacted) {
  //     setRecentContactedDateFilter(config.recentContacted);
  //   }
  // }, [activeFilter, dropdownOptions]);
  useEffect(() => {
    // if (!activeFilter) {
    //   return; // do not modify filters unless a quick filter is active
    // }

    const today = moment().startOf("day").toDate();
    const sevenDaysAgo = moment().subtract(7, "days").startOf("day").toDate();
    const nextYearToday = moment().add(1, "year").startOf("day").toDate();

    const filterConfig = {
      New: { lead: "New" },
      RecentSubscriber: { recentContacted: [today, today] },
      RecentContacted: {},
      ContactToday: { followUp: [today, today] },
      FutureContact: { lead: "Follow Up", followUp: [today, nextYearToday] },
      Followup: { lead: "Follow Up" },
      FollowupToday: { lead: "Follow Up", followUp: [today, today] },
      NotInterested: { lead: "Not Interested" },
      NoResponse: { lead: "No Response" },
      Prospect: { lead: "Prospect" },
      ProspectLost: { lead: "Prospect Lost" },
      Junk: { lead: "Junk" },
      Subscribed: { client: "Subscribed" },
      // IncomingCallReport: { lead: "Incoming Call" },
      Opened: { opened_times: "Opened" },
      Opened3Times: { opened_times: 3 },
      Opened5Times: { opened_times: 5 },
      Read: { isRead: 1 },
      Unread: { isRead: 0 },
      Hot: { aiTag: "Hot" },
      Warm: { aiTag: "Warm" },
      Value: { aiTag: "Value" },
      Escalate: { aiTag: "Escalate" },
      Subscribers: {} // Clear all filters for main Subscribers page
    };

    const config = filterConfig[activeFilter] || {};

    // IMPORTANT: Clear ALL existing filters first when a sidebar filter is clicked
    const clearAllSidebarFilters = () => {
      setJoinDateFilter([null, null]);
      setUidFilter("");
      setLeadSourceFilter("");
      setNameFilter("");
      setMobileFilter("");
      setAltMobileFilter("");
      setEmailFilter("");
      setAiTagFilter([]);
      setStateFilter("");
      setInvCapitalFilter("");
      setLeadStatusFilter([]);
      setExpInMarketFilter("");
      setInvestmentStatusFilter("");
      setConvertibleFilter("");
      setRecentContactedDateFilter([null, null]);
      setFollowUpDateFilter([null, null]);
      setLanguageFilter("");
      setClientStatusFilter([]);
      setSubscribedDateFilter([null, null]);
      setSubscriberStatusFilter([]);
      setAssignedToFilter("");
      setUpdatedOnDateFilter([null, null]);
      setUpdatedByFilter("");
      setDeviceIdFilter("");
      setUtmSourceFilter("");
      setUtmMediumFilter("");
      setUtmCampaignFilter("");
      setUtmContentFilter("");
      setUtmTermFilter("");
      setEmailFilterState(0);
      setTradeFilter(0);
      setStreetfolioFilter(0);
      setCategoryFilter("");
      setTradeCreatedOnFilter([null, null]);
      setFolioCreatedOnFilter([null, null]);
      setAssignedToFolioFilter("");
      setAssignedToResearchFilter("");
      setAskfpsFilter("");
      setInFolioFilter("");
      setSortField("");
      setSortOrder("");
    };

    setPage(1);

    // If it's the main Subscribers page or we want to clear all filters
    if (!activeFilter || activeFilter === "Subscribers") {
      // clearAllSidebarFilters();  
      fetchUsers(1);
      return;
    }

    // Clear all existing filters before applying sidebar filter
    clearAllSidebarFilters();

    // Apply only the sidebar filter
    const matchedLeadStatusItem = dropdownOptions.leadStatusList.find(
      (item) => item.pick_name === config.lead
    );
    const matchedClientStatusItem = dropdownOptions.clientStatusList.find(
      (item) => item.pick_name === config.client
    );

    if (matchedLeadStatusItem) {
      setLeadStatusFilter([matchedLeadStatusItem.pick_name]);
    } else if (config.lead) {
      setLeadStatusFilter([config.lead]);
    }
    if (matchedClientStatusItem) {
      setClientStatusFilter([matchedClientStatusItem.pick_name]);
    }
    if (config.followUp) {
      setFollowUpDateFilter(config.followUp);
    }
    if (config.recentContacted) {
      setRecentContactedDateFilter(config.recentContacted);
    }
    if (config.aiTag) {
      const isAlreadySelected =
        Array.isArray(aiTagFilter)
          ? aiTagFilter.length === 1 && aiTagFilter[0] === config.aiTag
          : aiTagFilter === config.aiTag;
      if (isAlreadySelected) {
        fetchUsers(1);
      } else {
        setAiTagFilter([config.aiTag]);
      }
    }

    if (
      activeFilter === "Read" ||
      activeFilter === "Unread" ||
      activeFilter === "Opened" ||
      activeFilter === "Opened3Times" ||
      activeFilter === "Opened5Times"
    ) {
      fetchUsers(1);
    }

    if (activeFilter === "RecentContacted") {
      setSortField("recent_contacted");
      setSortOrder("desc");
      fetchUsers(1);
    }

    // Don't fetch users here - the state updates will trigger fetchUsers automatically
    // via the existing useEffect dependencies
  }, [activeFilter, dropdownOptions]);
  // Function to handle clear filters event from sidebar
  const handleClearFiltersEvent = useCallback(() => {
    clearAllFilters();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setIsActionMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    window.addEventListener("clearSubscriberFiltersEvent", handleClearFiltersEvent);
    return () => {
      window.removeEventListener("clearSubscriberFiltersEvent", handleClearFiltersEvent);
    };
  }, [handleClearFiltersEvent]); // Empty dependency array - only runs once on mount
  const formatDateForAPI = (date) => {
    if (!date) return null;
    // If you need to include time to ensure full day coverage
    return moment(date).startOf("day").format("YYYY-MM-DD HH:mm:ss");
    // OR if your API expects just date
    // return moment(date).format("YYYY-MM-DD");
  };

  // Helper function to build filter params (reusable for all 3 APIs)
  const buildFilterParams = () => {
    const filterParams = {};

    if (joinDateFilter[0]) {
      filterParams.screated_on = formatDateForAPI(joinDateFilter[0]);
      filterParams.ecreated_on = formatDateForAPI(
        joinDateFilter[1] || joinDateFilter[0]
      );
    }
    if (uidFilter) filterParams.subscriberid = uidFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (altMobileFilter) filterParams.otherphone = altMobileFilter;
    if (emailFilter) filterParams.email = emailFilter;
    if (
      aiTagFilter &&
      (Array.isArray(aiTagFilter)
        ? aiTagFilter.length > 0
        : String(aiTagFilter).trim() !== "")
    ) {
      filterParams.ai_tag = Array.isArray(aiTagFilter)
        ? aiTagFilter.join(",")
        : aiTagFilter;
    } else if (
      activeFilter === "Hot" ||
      activeFilter === "Warm" ||
      activeFilter === "Value" ||
      activeFilter === "Escalate"
    ) {
      filterParams.ai_tag = activeFilter;
    }
    if (stateFilter) filterParams.state = stateFilter;
    if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
    if (leadStatusFilter && leadStatusFilter.length > 0)
      filterParams.lead_status = leadStatusFilter.join(",");
    if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
    if (investmentStatusFilter)
      filterParams.investments = investmentStatusFilter;
    if (convertibleFilter) filterParams.convertible = convertibleFilter;
    if (recentContactedDateFilter[0]) {
      filterParams.srecent_contacted = formatDateForAPI(
        recentContactedDateFilter[0]
      );
      filterParams.erecent_contacted = formatDateForAPI(
        recentContactedDateFilter[1] || recentContactedDateFilter[0]
      );
    }
    if (followUpDateFilter[0]) {
      filterParams.snext_followup = formatDateForAPI(followUpDateFilter[0]);
      filterParams.enext_followup = formatDateForAPI(
        followUpDateFilter[1] || followUpDateFilter[0]
      );
    }
    if (languageFilter) filterParams.language = languageFilter;
    if (clientStatusFilter && clientStatusFilter.length > 0)
      filterParams.client_status = clientStatusFilter.join(",");
    if (subscribedDateFilter[0]) {
      filterParams.ssubscribed_on = formatDateForAPI(subscribedDateFilter[0]);
      filterParams.esubscribed_on = formatDateForAPI(
        subscribedDateFilter[1] || subscribedDateFilter[0]
      );
    }
    if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
      filterParams.subscriber_status = subscriberStatusFilter.join(",");
    if (assignedToFilter) filterParams.assignedto = assignedToFilter;
    if (assignedToFolioFilter)
      filterParams.assignedto_folio = assignedToFolioFilter;
    if (assignedToResearchFilter)
      filterParams.r_assigned = assignedToResearchFilter;
    if (askfpsFilter !== "") filterParams.askfps = askfpsFilter;
    if (leadEnFilter !== "") filterParams.lead_en = leadEnFilter;
    if (updatedOnDateFilter[0]) {
      filterParams.supdated_on = formatDateForAPI(updatedOnDateFilter[0]);
      filterParams.eupdated_on = formatDateForAPI(
        updatedOnDateFilter[1] || updatedOnDateFilter[0]
      );
    }
    if (updatedByFilter) filterParams.updated_by = updatedByFilter;
    if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;
    if (emailFilterState === 1) filterParams.is_email = 1;
    else if (emailFilterState === 2) filterParams.is_email = 0;
    if (tradeFilter === 1) filterParams.istrade = 1;
    if (streetfolioFilter === 1) filterParams.isfolio = 1;
    if (categoryFilter !== "") filterParams.source = categoryFilter;
    if (inFolioFilter !== "") filterParams.in_folio = inFolioFilter;
    if (subscriptionAmountFilter) {
      const range = parseNumericRange(subscriptionAmountFilter);
      if (range.min !== undefined) filterParams.min_subscription_amount = range.min;
      if (range.max !== undefined) filterParams.max_subscription_amount = range.max;
    }
    if (firstAmountFilter) {
      const range = parseNumericRange(firstAmountFilter);
      if (range.min !== undefined) filterParams.min_first_amount = range.min;
      if (range.max !== undefined) filterParams.max_first_amount = range.max;
    }
    if (tradeCreatedOnFilter[0]) {
      filterParams.strade_created_on = formatDateForAPI(
        tradeCreatedOnFilter[0]
      );
      filterParams.etrade_created_on = formatDateForAPI(
        tradeCreatedOnFilter[1] || tradeCreatedOnFilter[0]
      );
    }
    if (folioCreatedOnFilter[0]) {
      filterParams.sfolio_created_on = formatDateForAPI(
        folioCreatedOnFilter[0]
      );
      filterParams.efolio_created_on = formatDateForAPI(
        folioCreatedOnFilter[1] || folioCreatedOnFilter[0]
      );
    }
    if (activeFilter === "Read") {
      filterParams.isRead = 1;
    } else if (activeFilter === "Unread") {
      filterParams.isRead = 0;
    } else if (activeFilter === "Opened") {
      filterParams.opened_times = "Opened";
    } else if (activeFilter === "Opened3Times") {
      filterParams.opened_times = 3;
    } else if (activeFilter === "Opened5Times") {
      filterParams.opened_times = 5;
    } else if (activeFilter === "Followup") {
      if (!filterParams.lead_status) filterParams.lead_status = "Follow Up";
    } else if (activeFilter === "FollowupToday") {
      if (!filterParams.lead_status) filterParams.lead_status = "Follow Up";
      if (!filterParams.snext_followup) {
        const todayDate = new Date();
        filterParams.snext_followup = formatDateForAPI(todayDate);
        filterParams.enext_followup = formatDateForAPI(todayDate);
      }
    } else if (activeFilter === "ProspectLost") {
      if (!filterParams.lead_status) filterParams.lead_status = "Prospect Lost";
    } else if (activeFilter === "RecentContacted") {
      filterParams.recent_contacted_24h = 1;
      if (!filterParams.orderbycol) {
        filterParams.orderbycol = "recent_contacted";
        filterParams.orderby = "desc";
      }
    }

    return filterParams;
  };

  // API 1: Fetch Subscriber List
  const fetchSubscriberList = async (pageNumber = 1) => {
    try {
      const startTime = performance.now();
      console.log(
        "⏳ [LIST API] Fetching subscriber list at:",
        new Date().toLocaleTimeString()
      );

      const filterParams = buildFilterParams();

      const response = await axios.post(
        `${API_URL}subscriber/list?page=${pageNumber}&limit=${limit}`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const apiEndTime = performance.now();
      console.log(
        "✅ [LIST API] Response received at:",
        new Date().toLocaleTimeString()
      );
      console.log(
        "⏱️ [LIST API DURATION] Time taken:",
        (apiEndTime - startTime).toFixed(2),
        "ms"
      );

      if (response.data.success && response.data.data) {
        const {
          subscribers,
          current_page,
          limit: responseLimit,
        } = response.data.data;
        const subscribersArray = Array.isArray(subscribers) ? subscribers : [];

        setUsers(subscribers);
        setFilteredUsers(subscribersArray);
        setHasMoreData(Math.ceil(subscribersArray.length / responseLimit));

        // Mark table as rendered
        requestAnimationFrame(() => {
          tableRenderedRef.current = true;
          checkRenderingStatus();
        });
      }
    } catch (error) {
      console.error("Error fetching subscriber list:", error);
      setError(error.message);
      showToast.error("Failed to fetch subscriber list: " + error.message);
    }
  };

  // API 2: Fetch Subscriber Count
  const fetchSubscriberCount = async () => {
    try {
      const startTime = performance.now();
      console.log(
        "⏳ [COUNT API] Fetching subscriber count at:",
        new Date().toLocaleTimeString()
      );

      const filterParams = buildFilterParams();

      const response = await axios.post(
        `${API_URL}subscriber/count`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const apiEndTime = performance.now();
      console.log(
        "✅ [COUNT API] Response received at:",
        new Date().toLocaleTimeString()
      );
      console.log(
        "⏱️ [COUNT API DURATION] Time taken:",
        (apiEndTime - startTime).toFixed(2),
        "ms"
      );

      if (response.data.success && response.data.data) {
        const { totalCount } = response.data.data;
        setTotalCount(totalCount || 0);
        setFilteredCount(totalCount || 0);
        setHasMoreData(Math.ceil((totalCount || 0) / limit));
      }
    } catch (error) {
      console.error("Error fetching subscriber count:", error);
      showToast.error("Failed to fetch subscriber count: " + error.message);
    }
  };

  // API 3: Fetch Subscriber Analytics
  const fetchSubscriberAnalytics = async () => {
    try {
      const startTime = performance.now();
      console.log(
        "⏳ [ANALYTICS API] Fetching subscriber analytics at:",
        new Date().toLocaleTimeString()
      );

      const filterParams = buildFilterParams();

      const response = await axios.post(
        `${API_URL}subscriber/analytics`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const apiEndTime = performance.now();
      console.log(
        "✅ [ANALYTICS API] Response received at:",
        new Date().toLocaleTimeString()
      );
      console.log(
        "⏱️ [ANALYTICS API DURATION] Time taken:",
        (apiEndTime - startTime).toFixed(2),
        "ms"
      );

      if (response.data.success && response.data.data) {
        const { subscription_amount, first_amount_total } = response.data.data;
        setTotalSubscriptionAmount(subscription_amount || 0);
        setTotalFirstAmount(first_amount_total || 0);
      }
    } catch (error) {
      console.error("Error fetching subscriber analytics:", error);
      showToast.error("Failed to fetch subscriber analytics: " + error.message);
    }
  };

  // Main function to fetch all data in sequence: List -> Dropdown -> Analytics
  // const fetchUsers = async (pageNumber = 1) => {
  //   try {
  //     setLoading(true);
  //     setIsRendering(true);
  //     tableRenderedRef.current = false;

  //     const overallStartTime = performance.now();
  //     console.log(
  //       "🚀 [FETCH USERS START] Starting data fetch at:",
  //       new Date().toLocaleTimeString()
  //     );

  //     // Step 1: Fetch List (Priority - show data first)
  //     await fetchSubscriberList(pageNumber);

  //     // Step 2: Fetch Dropdown Options (can load in background)
  //     await fetchDropdownOptions();

  //     // Step 3: Fetch Analytics (can load in background)
  //     await fetchSubscriberAnalytics();

  //     // Step 4: Fetch Count (can load in background)
  //     await fetchSubscriberCount();

  //     const overallEndTime = performance.now();
  //     console.log(
  //       "🎉 [FETCH USERS COMPLETE] All data loaded at:",
  //       new Date().toLocaleTimeString()
  //     );
  //     console.log(
  //       "⏳ [TOTAL TIME] All APIs took:",
  //       (overallEndTime - overallStartTime).toFixed(2),
  //       "ms"
  //     );
  //   } catch (error) {
  //     console.error("Error in fetchUsers:", error);
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchUsers = async (pageNumber = 1) => {
    try {
      setLoading(true);
      setIsRendering(true);
      tableRenderedRef.current = false;

      const overallStartTime = performance.now();
      console.log("🚀 [FETCH USERS START]");

      // ✅ STEP 1: Fetch MAIN TABLE DATA (blocking)
      await fetchSubscriberList(pageNumber);

      // ✅ STOP TABLE LOADING AS SOON AS LIST IS READY
      setIsRendering(false);

      // ✅ STEP 2: Load remaining APIs IN PARALLEL (non-blocking)
      Promise.allSettled([
        fetchSubscriberAnalytics(),
        fetchSubscriberCount(),
      ]).then((results) => {
        console.log("📦 Background APIs finished:", results);
      });

      const overallEndTime = performance.now();
      console.log(
        "⏳ List loaded in:",
        (overallEndTime - overallStartTime).toFixed(2),
        "ms"
      );
    } catch (error) {
      console.error("Error in fetchUsers:", error);
      setError(error.message);
    } finally {
      // ❌ DO NOT stop loading here for table
      setLoading(false);
    }
  };

  const toggleEmailFilter = () => {
    setEmailFilterState((prev) => (prev === 0 ? 1 : prev === 1 ? 2 : 0));
  };
  const toggleTradeFilter = () => {
    setTradeFilter((prev) => (prev === 0 ? 1 : 0));
  };

  const toggleStreetfolioFilter = () => {
    setStreetfolioFilter((prev) => (prev === 0 ? 1 : 0));
  };

  // Helper to compare simple arrays (used to avoid unnecessary state updates)
  const arraysEqual = (a, b) => {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i += 1) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };

  // Helper to compare date ranges [start, end]
  const areDateRangesEqual = (r1, r2) => {
    const [s1, e1] = r1 || [];
    const [s2, e2] = r2 || [];
    const getTime = (d) => (d instanceof Date ? d.getTime() : d || null);
    return getTime(s1) === getTime(s2) && getTime(e1) === getTime(e2);
  };

  const checkRenderingStatus = useCallback(() => {
    if (tableRenderedRef.current) {
      // Add a small delay to ensure the table is fully rendered
      setTimeout(() => {
        setIsRendering(false);
      }, 300);
    }
  }, []);

  useEffect(() => {
    if (filteredUsers.length > 0) {
      checkRenderingStatus();
    }
  }, [filteredUsers, checkRenderingStatus]);

  useEffect(() => {
    setTempPage(page);
  }, [page]);

  const fetchDropdownOptions = async () => {
    try {
      const startTime = performance.now();
      console.log(
        "⏳ [DROPDOWN API CALL START] Fetching dropdown options at:",
        new Date().toLocaleTimeString()
      );
      // Don't set loading here as it's managed by fetchUsers

      // Make three API calls in parallel
      const [dropdownResponse, serviceResponse, templateResponse] =
        await Promise.all([
          axios.get(`${API_URL}subscriber/get-dropdown`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(`${API_URL}subscriber/get-dropdown-other`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(`${API_URL}subscriber/get-template`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);
      const apiEndTime = performance.now();
      console.log(
        "✅ [DROPDOWN API CALL END] All responses received at:",
        new Date().toLocaleTimeString()
      );
      console.log(
        "⏱️ [DROPDOWN API DURATION] Time taken for parallel API calls:",
        (apiEndTime - startTime).toFixed(2),
        "ms"
      );
      console.log("📊 [DROPDOWN API RESULTS]", {
        "get-dropdown": dropdownResponse.data?.success
          ? "✅ Success"
          : "❌ Failed",
        "get-dropdown-other": serviceResponse.data?.success
          ? "✅ Success"
          : "❌ Failed",
        "get-template": templateResponse.data?.success
          ? "✅ Success"
          : "❌ Failed",
      });

      if (dropdownResponse.data.success && dropdownResponse.data.data) {
        setDropdownOptions((prevOptions) => ({
          ...prevOptions,
          leadSourceList: dropdownResponse.data.data.leadSource || [],
          languageList: dropdownResponse.data.data.languageList || [],
          leadStatusList: dropdownResponse.data.data.leadStatus || [],
          invCapitalList: dropdownResponse.data.data.invCapital || [],
          expInMarketList: dropdownResponse.data.data.expInMarket || [],
          investmentsList: dropdownResponse.data.data.investments || [],
          convertibleList: dropdownResponse.data.data.convertible || [],
          clientStatusList: dropdownResponse.data.data.clientStatus || [],
          statusList: dropdownResponse.data.data.subscriberStatus || [],
          assignedUserList: dropdownResponse.data.data.assignedTo || [],
          assignedResearchUserList:
            dropdownResponse.data.data.assignedToResearch || [],
          fullUserList: dropdownResponse.data.data.fullUserList || [],
          stateList: dropdownResponse.data.data.stateList || [],
          utmSourceList: dropdownResponse.data.data.utmSource || [],
          utmMediumList: dropdownResponse.data.data.utmMedium || [],
          utmCampaignList: dropdownResponse.data.data.utmCampaign || [],
          utmContentList: dropdownResponse.data.data.utmContent || [],
          utmTermList: dropdownResponse.data.data.utmTerm || [],
          subscriberStatusList:
            dropdownResponse.data.data.subscriber_statuslist || [],
          dematBrokersList: dropdownResponse.data.data.dematborkerslist || [],
          riskLevelList: dropdownResponse.data.data.riskLevels || [],
          priceExpectedList: dropdownResponse.data.data.priceexpectedlist || [],
          interestSegmentsList:
            dropdownResponse.data.data.interest_segmentlist || [],
          reasonNotInterestedList:
            dropdownResponse.data.data.notInterestedReasons || [],
          updatedByUserList: dropdownResponse.data.data.modifiedBy || [],
          sourceList: dropdownResponse.data.data.sourceList || [],
        }));
      }

      // Handle service list from the second API
      if (
        serviceResponse.data?.success &&
        serviceResponse.data?.data?.servicelist
      ) {
        console.log(
          "📦 [SERVICE LIST] Loaded",
          serviceResponse.data.data.servicelist?.length || 0,
          "services"
        );
        setDropdownOptions((prevOptions) => ({
          ...prevOptions,
          serviceList: serviceResponse.data.data.servicelist || [],
        }));
      }

      console.log("serviceResponse", serviceResponse);

      // Handle templates from the third API
      if (templateResponse.data?.success && templateResponse.data?.data) {
        const { templatePushNotificationList, templateSmsList } =
          templateResponse.data.data;
        setDropdownOptions((prevOptions) => ({
          ...prevOptions,
          templatePushNotificationList: templatePushNotificationList || [],
          templateSmsList: templateSmsList || [],
        }));
      }
      const finalEndTime = performance.now();
      console.log(
        "🎉 [DROPDOWN DATA LOADED] All options set at:",
        new Date().toLocaleTimeString()
      );
      console.log(
        "⏳ [DROPDOWN TOTAL TIME] API + State updates took:",
        (finalEndTime - startTime).toFixed(2),
        "ms"
      );
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
      // Loading state is managed by fetchUsers
    }
  };

  // Fetch dropdown options once on component mount
  useEffect(() => {
    fetchDropdownOptions();
  }, []);

  useEffect(() => {
    fetchUsers(page);
  }, [
    page,
    // uidFilter,
    leadSourceFilter,
    // nameFilter,
    // mobileFilter,
    // altMobileFilter,
    // emailFilter,
    aiTagFilter,
    stateFilter,
    invCapitalFilter,
    leadStatusFilter,
    expInMarketFilter,
    investmentStatusFilter,
    convertibleFilter,
    languageFilter,
    clientStatusFilter,
    subscriberStatusFilter,
    assignedToFilter,
    assignedToFolioFilter,
    assignedToResearchFilter,
    askfpsFilter,
    leadEnFilter,
    updatedByFilter,
    // deviceIdFilter,
    utmSourceFilter,
    utmMediumFilter,
    utmCampaignFilter,
    utmContentFilter,
    utmTermFilter,
    // sortField,
    // sortOrder,
    emailFilterState,
    tradeFilter,
    streetfolioFilter,
    categoryFilter,
    inFolioFilter,
    // activeFilter,
    // Date filters removed - they should only trigger API calls when search button is clicked
    searchTrigger,
  ]);

  // fetchDropdownOptions is now called from fetchUsers to maintain proper loading sequence
  // Removed separate useEffect to avoid duplicate calls

  // Keep the filters for the session so Subscriber edit can reuse them for Next/Previous
  const saveFilterParams = (filterParams) => {
    try {
      sessionStorage.setItem(
        "subscriberFilterParams",
        JSON.stringify(filterParams)
      );
    } catch (error) {
      console.error("Error saving subscriber filters:", error);
    }
  };

  const handleRowClick = (id) => {
    if (!hasPermission("subscriber", "view")) {
      return; // no navigation without edit permission
    }
    const filterParams = buildFilterParams();
    filterParams.currentPage = page;
    filterParams.limit = limit;
    saveFilterParams(filterParams);

    navigate(`/Subscriber/Edit/${id}`, {
      state: {
        filterParams,
      },
    });
  };

  // Modal state and form data
  const [isModalOpenSubscriber, setIsModalOpenSubscriber] = useState(false);
  const [isModalOpenFreeService, setIsModalOpenFreeService] = useState(false);
  const [isModalOpenStreetStocks, setIsModalOpenStreetStocks] = useState(false);
  const [isModalOpenSendPushNotification, setIsModalOpenSendPushNotification] =
    useState(false);
  const [isModalOpenSendSms, setisModalOpenSendSms] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    mobileno: "",
    email: "",
    lead_source: "",
    language: "",
  });
  const [serviceData, setServiceData] = useState({
    fullname: "",
    mobileno: "",
    email: "",
    languageid: "",
    serviceid: "",
    stype: "Free",
    tradesTotal: 0,
  });
  const [sendPushData, setSendPushData] = useState({
    title: "",
    pushTemplate: "",
    message: "",
  });
  const [sendSmsData, setSendSmsData] = useState({
    pushTemplate: "",
    message: "",
  });
  const [smsTemplateData, setSmsTemplateData] = useState({
    template: null,
  });
  const [isLoadingSmsTemplate, setIsLoadingSmsTemplate] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Handle input changes and update form data
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleServiceInputChange = (e) => {
    const { name, value } = e.target;
    setServiceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSendPushInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "pushTemplate") {
      const selectedTemplate =
        dropdownOptions.templatePushNotificationList?.find(
          (template) => template.id === parseInt(value)
        );

      setSendPushData((prevData) => ({
        ...prevData,
        pushTemplate: value,
        message: selectedTemplate
          ? decodeHTMLEntities(selectedTemplate.message)
          : "",
      }));
    } else {
      setSendPushData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSendSmsInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "pushTemplate") {
      const selectedTemplate = dropdownOptions.templateSmsList?.find(
        (template) => template.id === parseInt(value)
      );

      setSendSmsData((prevData) => ({
        ...prevData,
        pushTemplate: value,
        message: selectedTemplate
          ? decodeHTMLEntities(selectedTemplate.message)
          : "",
      }));
    } else {
      setSendSmsData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const decodeHTMLEntities = (text) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  const handleCheckboxChange = (id, checked) => {
    if (checked) {
      setSelectedSubscribers((prev) => [...prev, id]);
    } else {
      setSelectedSubscribers((prev) => prev.filter((subId) => subId !== id));
      // If unchecking and checkingAll was true, set it to false
      if (checkingAll) {
        setCheckingAll(false);
      }
    }
  };

  // Check if we should show "Select All Records" button
  useEffect(() => {
    // Show the button when all visible records are selected but total count is greater
    const allVisibleSelected =
      filteredUsers.length > 0 &&
      selectedSubscribers.length === filteredUsers.length &&
      totalCount > filteredUsers.length &&
      !checkingAll;
    setShowSelectAllButton(allVisibleSelected);
  }, [selectedSubscribers, filteredUsers, totalCount, checkingAll]);

  const handleActionChange = async (action) => {
    if (action === "delete") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to delete");
        return;
      }
      if (!hasPermission("subscriber", "delete")) {
        showToast.warning("You don't have permission to delete subscribers");
        return;
      }

      // 🔔 SweetAlert instead of window.confirm
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to delete ${selectedSubscribers.length} subscriber(s). This action cannot be undone!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      });

      if (result.isConfirmed) {
        try {
          const filterParams = {};

          if (joinDateFilter[0] && joinDateFilter[1])
            filterParams.screated_on = joinDateFilter[0];
          if (joinDateFilter[0] && joinDateFilter[1])
            filterParams.ecreated_on = joinDateFilter[1];
          if (uidFilter) filterParams.subscriberid = uidFilter;
          if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
          if (nameFilter) filterParams.fullname = nameFilter;
          if (mobileFilter) filterParams.mobileno = mobileFilter;
          if (altMobileFilter) filterParams.otherphone = altMobileFilter;
          if (emailFilter) filterParams.email = emailFilter;
          if (
            aiTagFilter &&
            (Array.isArray(aiTagFilter)
              ? aiTagFilter.length > 0
              : String(aiTagFilter).trim() !== "")
          )
            filterParams.ai_tag = Array.isArray(aiTagFilter)
              ? aiTagFilter.join(",")
              : aiTagFilter;
          if (stateFilter) filterParams.state = stateFilter;
          if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
          if (leadStatusFilter && leadStatusFilter.length > 0)
            filterParams.lead_status = leadStatusFilter.join(",");
          if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
          if (investmentStatusFilter)
            filterParams.investments = investmentStatusFilter;
          if (convertibleFilter) filterParams.convertible = convertibleFilter;
          if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
            filterParams.srecent_contacted = recentContactedDateFilter[0];
          if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
            filterParams.erecent_contacted = recentContactedDateFilter[1];
          if (followUpDateFilter[0] && followUpDateFilter[1])
            filterParams.snext_followup = followUpDateFilter[0];
          if (followUpDateFilter[0] && followUpDateFilter[1])
            filterParams.enext_followup = followUpDateFilter[1];
          if (languageFilter) filterParams.language = languageFilter;
          if (clientStatusFilter && clientStatusFilter.length > 0)
            filterParams.client_status = clientStatusFilter.join(",");
          if (subscribedDateFilter[0] && subscribedDateFilter[1])
            filterParams.ssubscribed_on = subscribedDateFilter[0];
          if (subscribedDateFilter[0] && subscribedDateFilter[1])
            filterParams.esubscribed_on = subscribedDateFilter[1];
          if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
            filterParams.status = subscriberStatusFilter.join(",");
          if (assignedToFilter) filterParams.assignedto = assignedToFilter;
          if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
            filterParams.supdated_on = updatedOnDateFilter[0];
          if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
            filterParams.eupdated_on = updatedOnDateFilter[1];
          if (updatedByFilter) filterParams.updated_by = updatedByFilter;
          if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
          if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
          if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
          if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
          if (utmContentFilter) filterParams.utm_content = utmContentFilter;
          if (utmTermFilter) filterParams.utm_term = utmTermFilter;
          if (sortField) filterParams.orderbycol = sortField;
          if (sortOrder) filterParams.orderby = sortOrder;
          if (isEmailFilterEnabled) filterParams.is_email = 1;

          const response = await axios.post(
            `${API_URL}subscriber/delete?checkAll=${checkingAll}`,
            { filters: filterParams, selectedIds: selectedSubscribers },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          showToast.success(
            response.data.message || "Subscribers deleted successfully"
          );
          setSelectedSubscribers([]);
          fetchUsers();
        } catch (error) {
          console.error("Error deleting subscribers:", error);
          console.log(error.response?.data || "Unknown error");
          showToast.error("An error occurred while deleting subscribers");
        }
      }
    } else if (action === "bulkEdit") {
      if (!hasPermission("subscriber", "edit")) {
        showToast.warning("You don't have permission to edit subscribers");
        return;
      }
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to edit");
        return;
      }

      // Open the bulk edit modal
      setIsBulkEditModalOpen(true);
    } else if (action === "sendPush") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning(
          "Please select at least one subscriber to send push notification"
        );
        return;
      }

      setIsModalOpenSendPushNotification(true);
    } else if (action === "bulkExport") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to export");
        return;
      }

      handleBulkExport(selectedSubscribers);
    } else if (action === "sendSms") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to send SMS");
        return;
      }

      // Fetch SMS template data before opening modal
      fetchSmsTemplate();
      setisModalOpenSendSms(true);
    } else if (action === "bulkImport") {
      // if (selectedSubscribers.length === 0) {
      //   showToast.warning(
      //     "Please select at least one subscriber to import data"
      //   );
      //   return;
      // }
      setIsModalOpenBulkImport(true);
    } else if (action === "sendEmail") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning(
          "Please select at least one subscriber to send email"
        );
        return;
      }

      fetchEmailTemplates(); // Optional, if not fetched before
      setIsModalOpenSendEmail(true);
    } else if (action === "downloadSample") {
      handleDownloadSample();
    } else if (action === "campaign") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning(
          "Please select at least one subscriber to add to campaign"
        );
        return;
      }
      setIsCampaignModalOpen(true);
    } else if (action === "aiCallCampaign") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning(
          "Please select at least one subscriber to launch AI Call Campaign"
        );
        return;
      }
      setIsAICampaignModalOpen(true);
    } else if (action === "aiSarvamCampaign") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning(
          "Please select at least one subscriber to launch Sarvam AI Campaign"
        );
        return;
      }
      setIsSarvamCampaignModalOpen(true);
    } else if (action === "broadcast") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to export");
        return;
      }
      setIsBroadcastModalOpen(true);
    } else if (action === "campaignExport") {
      if (selectedSubscribers.length === 0 && !checkingAll) {
        showToast.warning("Please select at least one subscriber to export");
        return;
      }

      // handleCampaignExport(selectedSubscribers);
      setIsCampaignExportOpen(true);
    }
  };

  const handleSendPushNotification = async (e) => {
    e.preventDefault();
    setCampaignLoading(true); // optional: if you want a loader like in campaign

    const filterParams = {};

    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.screated_on = joinDateFilter[0];
    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.ecreated_on = joinDateFilter[1];
    if (uidFilter) filterParams.subscriberid = uidFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (altMobileFilter) filterParams.otherphone = altMobileFilter;
    if (emailFilter) filterParams.email = emailFilter;
    if (
      aiTagFilter &&
      (Array.isArray(aiTagFilter)
        ? aiTagFilter.length > 0
        : String(aiTagFilter).trim() !== "")
    )
      filterParams.ai_tag = Array.isArray(aiTagFilter)
        ? aiTagFilter.join(",")
        : aiTagFilter;
    if (stateFilter) filterParams.state = stateFilter;
    if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
    if (leadStatusFilter && leadStatusFilter.length > 0)
      filterParams.lead_status = leadStatusFilter.join(",");
    if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
    if (investmentStatusFilter)
      filterParams.investments = investmentStatusFilter;
    if (convertibleFilter) filterParams.convertible = convertibleFilter;
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.srecent_contacted = recentContactedDateFilter[0];
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.erecent_contacted = recentContactedDateFilter[1];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.snext_followup = followUpDateFilter[0];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.enext_followup = followUpDateFilter[1];
    if (languageFilter) filterParams.language = languageFilter;
    if (clientStatusFilter && clientStatusFilter.length > 0)
      filterParams.client_status = clientStatusFilter.join(",");
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.ssubscribed_on = subscribedDateFilter[0];
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.esubscribed_on = subscribedDateFilter[1];
    if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
      filterParams.status = subscriberStatusFilter.join(",");
    if (assignedToFilter) filterParams.assignedto = assignedToFilter;
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.supdated_on = updatedOnDateFilter[0];
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.eupdated_on = updatedOnDateFilter[1];
    if (updatedByFilter) filterParams.updated_by = updatedByFilter;
    if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;

    try {
      setLoading(true);
      const payload = {
        title: sendPushData.title,
        message: sendPushData.message,
        selectedIds: checkingAll ? [] : selectedSubscribers, // send IDs only if not checkingAll
        filters: checkingAll ? filterParams : {}, // send filters only if checkingAll
      };

      const response = await axios.post(
        `${API_URL}subscriber/send-subscriber-push?checkingAll=${checkingAll}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        showToast.success(
          response.data.message || "Push Notification Sent Successfully"
        );
        setSelectedSubscribers([]);
        fetchUsers();

        // Close modal and reset form after a delay
        setTimeout(() => {
          setIsModalOpenSendPushNotification(false);
          setMessage("");
          setMessageType("");
          setSendPushData({
            title: "",
            pushTemplate: "",
            message: "",
          });
          setSelectedSubscribers([]);
        }, 2000);
      }
    } catch (error) {
      console.log(error.response?.data || "Unknown error");
      showToast.error("An error occurred while sending push notification");
    } finally {
      setCampaignLoading(false);
      setLoading(true);
    }
  };

  const handleSendSmsSubmit = async (e) => {
    e.preventDefault();

    if (!sendSmsData.message) {
      showToast.warning("Please enter a message");
      return;
    }

    const filterParams = {};

    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.screated_on = joinDateFilter[0];
    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.ecreated_on = joinDateFilter[1];
    if (uidFilter) filterParams.subscriberid = uidFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (altMobileFilter) filterParams.otherphone = altMobileFilter;
    if (emailFilter) filterParams.email = emailFilter;
    if (
      aiTagFilter &&
      (Array.isArray(aiTagFilter)
        ? aiTagFilter.length > 0
        : String(aiTagFilter).trim() !== "")
    )
      filterParams.ai_tag = Array.isArray(aiTagFilter)
        ? aiTagFilter.join(",")
        : aiTagFilter;
    if (stateFilter) filterParams.state = stateFilter;
    if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
    if (leadStatusFilter && leadStatusFilter.length > 0)
      filterParams.lead_status = leadStatusFilter.join(",");
    if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
    if (investmentStatusFilter)
      filterParams.investments = investmentStatusFilter;
    if (convertibleFilter) filterParams.convertible = convertibleFilter;
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.srecent_contacted = recentContactedDateFilter[0];
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.erecent_contacted = recentContactedDateFilter[1];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.snext_followup = followUpDateFilter[0];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.enext_followup = followUpDateFilter[1];
    if (languageFilter) filterParams.language = languageFilter;
    if (clientStatusFilter && clientStatusFilter.length > 0)
      filterParams.client_status = clientStatusFilter.join(",");
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.ssubscribed_on = subscribedDateFilter[0];
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.esubscribed_on = subscribedDateFilter[1];
    if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
      filterParams.status = subscriberStatusFilter.join(",");
    if (assignedToFilter) filterParams.assignedto = assignedToFilter;
    if (askfpsFilter !== "") filterParams.askfps = askfpsFilter;
    if (leadEnFilter !== "") filterParams.lead_en = leadEnFilter;
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.supdated_on = updatedOnDateFilter[0];
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.eupdated_on = updatedOnDateFilter[1];
    if (updatedByFilter) filterParams.updated_by = updatedByFilter;
    if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;

    try {
      setLoading(true);
      const payload = {
        message: sendSmsData.message,
        selectedIds: checkingAll ? [] : selectedSubscribers, // send IDs only if not checkingAll
        filters: checkingAll ? filterParams : {}, // send filters only if checkingAll
        template: smsTemplateData.template,
      };

      const response = await axios.post(
        `${API_URL}subscriber/send-sms-bulk?checkingAll=${checkingAll}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        showToast.success(response.data.message || "Sms Send Successfully");
        setSelectedSubscribers([]);
        fetchUsers();

        // Close the modal after a delay
        setTimeout(() => {
          setisModalOpenSendSms(false);
          setMessage("");
          setMessageType("");
          setSendSmsData({
            pushTemplate: "",
            message: "",
          });
          setSelectedSubscribers([]);
        }, 2000);
      }
    } catch (error) {
      console.log(error.response?.data || "Unknown error");
      showToast.error("An error occurred while sending SMS");
    } finally {
      setLoading(false);
    }
  };

  const handleBulkEditSubmit = async (e) => {
    e.preventDefault();

    if (selectedSubscribers.length === 0 && !checkingAll) {
      showToast.warning("No subscribers selected for update");
      return;
    }

    // Filter out empty fields to only update fields that have been changed
    const updateData = {};
    Object.keys(bulkEditData).forEach((key) => {
      if (bulkEditData[key] !== "") {
        // Convert ID to actual value based on the field type
        let value = bulkEditData[key];

        switch (key) {
          case "lead_source":
            const leadSourceItem = dropdownOptions.leadSourceList.find(
              (item) => item.id == value
            );
            value = leadSourceItem ? leadSourceItem.pick_name : value;
            break;

          case "state":
            const state = dropdownOptions.stateList?.find(
              (item) => item.stateCode == value || item.stateName == value
            );
            value = state ? String(state.stateCode) : value;
            break;

          case "occupation":
            const occupation = value;
            value = occupation ? value : value;
            break;

          case "language":
            const languageItem = dropdownOptions.languageList?.find(
              (item) => item.id == value || item.name == value
            );
            value = languageItem ? String(languageItem.id) : value;
            break;

          case "exp_in_market":
            const expInMarketItem = dropdownOptions.expInMarketList.find(
              (item) => item.id == value
            );
            value = expInMarketItem ? expInMarketItem.pick_name : value;
            break;

          case "inv_capital":
            const invCapitalItem = dropdownOptions.invCapitalList.find(
              (item) => item.id == value
            );
            value = invCapitalItem ? invCapitalItem.pick_name : value;
            break;

          case "risk_level":
            const riskLevel = dropdownOptions.riskLevelList.find(
              (item) => item.id == value
            );
            value = riskLevel ? riskLevel.pick_name : value;
            break;

          case "lead_status":
            const leadStatusItem = dropdownOptions.leadStatusList.find(
              (item) => item.id == value
            );
            value = leadStatusItem ? leadStatusItem.pick_name : value;
            break;

          case "assignedto":
            const assignedToItem = dropdownOptions.assignedUserList?.find(
              (item) => item.tu_id == value || item.id == value
            );
            value = assignedToItem ? Number(assignedToItem.tu_id || assignedToItem.id) : Number(value);
            // Also update assignedto_folio with the same value
            updateData["assignedto_folio"] = value;
            break;

          case "reason_not_interested":
            const resonNotInterested =
              dropdownOptions.reasonNotInterestedList.find(
                (item) => item.id == value
              );
            value = resonNotInterested ? resonNotInterested.pick_name : value;
            break;

          case "lead_en":
            value = Number(value);
            break;
        }

        updateData[key] = value;
      }
    });

    if (Object.keys(updateData).length === 0) {
      alert("No changes to update");
      return;
    }

    try {
      setIsLoading(true);

      const filterParams = {};

      if (joinDateFilter[0] && joinDateFilter[1])
        filterParams.screated_on = joinDateFilter[0];
      if (joinDateFilter[0] && joinDateFilter[1])
        filterParams.ecreated_on = joinDateFilter[1];
      if (uidFilter) filterParams.subscriberid = uidFilter;
      if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
      if (nameFilter) filterParams.fullname = nameFilter;
      if (mobileFilter) filterParams.mobileno = mobileFilter;
      if (altMobileFilter) filterParams.otherphone = altMobileFilter;
      if (emailFilter) filterParams.email = emailFilter;
      if (
        aiTagFilter &&
        (Array.isArray(aiTagFilter)
          ? aiTagFilter.length > 0
          : String(aiTagFilter).trim() !== "")
      )
        filterParams.ai_tag = Array.isArray(aiTagFilter)
          ? aiTagFilter.join(",")
          : aiTagFilter;
      if (stateFilter) filterParams.state = stateFilter;
      if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
      if (leadStatusFilter && leadStatusFilter.length > 0)
        filterParams.lead_status = leadStatusFilter.join(",");
      if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
      if (investmentStatusFilter)
        filterParams.investments = investmentStatusFilter;
      if (convertibleFilter) filterParams.convertible = convertibleFilter;
      if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
        filterParams.srecent_contacted = recentContactedDateFilter[0];
      if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
        filterParams.erecent_contacted = recentContactedDateFilter[1];
      if (followUpDateFilter[0] && followUpDateFilter[1])
        filterParams.snext_followup = followUpDateFilter[0];
      if (followUpDateFilter[0] && followUpDateFilter[1])
        filterParams.enext_followup = followUpDateFilter[1];
      if (languageFilter) filterParams.language = languageFilter;
      if (clientStatusFilter && clientStatusFilter.length > 0)
        filterParams.client_status = clientStatusFilter.join(",");
      if (subscribedDateFilter[0] && subscribedDateFilter[1])
        filterParams.ssubscribed_on = subscribedDateFilter[0];
      if (subscribedDateFilter[0] && subscribedDateFilter[1])
        filterParams.esubscribed_on = subscribedDateFilter[1];
      if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
        filterParams.status = subscriberStatusFilter.join(",");
      if (assignedToFilter) filterParams.assignedto = assignedToFilter;
      if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
        filterParams.supdated_on = updatedOnDateFilter[0];
      if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
        filterParams.eupdated_on = updatedOnDateFilter[1];
      if (updatedByFilter) filterParams.updated_by = updatedByFilter;
      if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
      if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
      if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
      if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
      if (utmContentFilter) filterParams.utm_content = utmContentFilter;
      if (utmTermFilter) filterParams.utm_term = utmTermFilter;
      if (sortField) filterParams.orderbycol = sortField;
      if (sortOrder) filterParams.orderby = sortOrder;

      const payload = {
        selectedIds: selectedSubscribers,
        updates: updateData,
        filters: filterParams,
      };

      console.log("Sending payload:", payload);

      const response = await axios.post(
        `${API_URL}subscriber/bulk-update?checkAll=${checkingAll}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        showToast.success(
          response.data.message || "Subscribers updated successfully"
        );
        setMessage(response.data.message || "Subscribers updated successfully");
        setMessageType("success");
        fetchUsers();

        // Close the modal after a delay
        setTimeout(() => {
          setIsBulkEditModalOpen(false);
          setMessage("");
          setMessageType("");
          setBulkEditData({
            lead_source: "",
            state: "",
            occupation: "",
            language: "",
            exp_in_market: "",
            inv_capital: "",
            risk_level: "",
            lead_status: "",
            assignedto: "",
            reason_not_interested: "",
          });
          // Clear selected subscribers after successful update
          setSelectedSubscribers([]);
          setCheckingAll(false);
          setShowSelectAllButton(false);
        }, 2000);
      } else {
        showToast.error(
          response.data.message || "Failed to update subscribers"
        );
        setMessage(response.data.message || "Failed to update subscribers");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error updating subscribers:", error);

      if (error.response) {
        console.log("Error response data:", error.response.data);
        console.log("Error response status:", error.response.status);
        console.log("Error response headers:", error.response.headers);

        showToast.error(error.response.data.message || "Server error occurred");
        setMessage(error.response.data.message || "Server error occurred");
      } else if (error.request) {
        console.log("Error request:", error.request);
        showToast.error("No response received from server");
        setMessage("No response received from server");
      } else {
        console.log("Error message:", error.message);
        showToast.error("Error setting up request: " + error.message);
        setMessage("Error setting up request: " + error.message);
      }

      setMessageType("error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkEditChange = (e) => {
    const { name, value } = e.target;
    setBulkEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleAddSubscriber = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Show loading spinner

    try {
      const payload = {
        ...formData,
        language: (formData.language === "" || formData.language === "0" || formData.language === null || formData.language === undefined) ? 0 : formData.language,
      };

      const response = await axios.post(
        `${API_URL}subscriber/save-subscriber`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      //  Acttual API URL should be used here 221
      if (response.data.success === true) {
        showToast.success(
          response.data.message || "Subscriber added successfully"
        );
        setMessage(response.data.message); // Success message
        setMessageType("success");
        setTimeout(() => closeModal(), 2000); // Close the modal after 2 seconds
        fetchUsers();
      } else {
        showToast.error(response.data.message || "Failed to add subscriber");
        setMessage(response.data.message); // Error message
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle form submission
  const handleAddfreeService = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true); // Show loading spinner
      const response = await axios.post(
        `${API_URL}subscription/save-free-service`,
        serviceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      //  Acttual API URL should be used here 221
      if (response.data.success === true) {
        showToast.success(
          response.data.message || "Service added successfully"
        );
        setMessage(response.data.message); // Success message
        setMessageType("success");
        setTimeout(() => closeModal(), 2000); // Close the modal after 2 seconds
        fetchUsers();
      } else {
        showToast.error(response.data.message || "Failed to add Service");
        setMessage(response.data.message); // Error message
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkExport = async (selectedSubscriber) => {
    const filterParams = {};

    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.screated_on = joinDateFilter[0];
    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.ecreated_on = joinDateFilter[1];
    if (uidFilter) filterParams.subscriberid = uidFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (altMobileFilter) filterParams.otherphone = altMobileFilter;
    if (emailFilter) filterParams.email = emailFilter;
    if (
      aiTagFilter &&
      (Array.isArray(aiTagFilter)
        ? aiTagFilter.length > 0
        : String(aiTagFilter).trim() !== "")
    )
      filterParams.ai_tag = Array.isArray(aiTagFilter)
        ? aiTagFilter.join(",")
        : aiTagFilter;
    if (stateFilter) filterParams.state = stateFilter;
    if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
    if (leadStatusFilter && leadStatusFilter.length > 0)
      filterParams.lead_status = leadStatusFilter.join(",");
    if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
    if (investmentStatusFilter)
      filterParams.investments = investmentStatusFilter;
    if (convertibleFilter) filterParams.convertible = convertibleFilter;
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.srecent_contacted = recentContactedDateFilter[0];
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.erecent_contacted = recentContactedDateFilter[1];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.snext_followup = followUpDateFilter[0];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.enext_followup = followUpDateFilter[1];
    if (languageFilter) filterParams.language = languageFilter;
    if (clientStatusFilter && clientStatusFilter.length > 0)
      filterParams.client_status = clientStatusFilter.join(",");
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.ssubscribed_on = subscribedDateFilter[0];
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.esubscribed_on = subscribedDateFilter[1];
    if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
      filterParams.status = subscriberStatusFilter.join(",");
    if (assignedToFilter) filterParams.assignedto = assignedToFilter;
    if (askfpsFilter !== "") filterParams.askfps = askfpsFilter;
    if (leadEnFilter !== "") filterParams.lead_en = leadEnFilter;
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.supdated_on = updatedOnDateFilter[0];
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.eupdated_on = updatedOnDateFilter[1];
    if (updatedByFilter) filterParams.updated_by = updatedByFilter;
    if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;
    if (subscriptionAmountFilter) {
      const range = parseNumericRange(subscriptionAmountFilter);
      if (range.min !== undefined) filterParams.min_subscription_amount = range.min;
      if (range.max !== undefined) filterParams.max_subscription_amount = range.max;
    }
    if (firstAmountFilter) {
      const range = parseNumericRange(firstAmountFilter);
      if (range.min !== undefined) filterParams.min_first_amount = range.min;
      if (range.max !== undefined) filterParams.max_first_amount = range.max;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}subscriber/export`,
        { selectedIds: selectedSubscriber, filters: filterParams }, // Put the data in the 'data' property,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "application/json",
          },
          params: {
            checkAll: checkingAll,
          },
          responseType: "blob",
        }
      );

      if (response.status == 200 || response.status == 201) {
        const now = new Date();
        const formattedDate = now
          .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
          .replace(/[/, ]+/g, "_"); // Replace separators with underscores

        const fileName = `SubscriberList-${formattedDate}.xlsx`;

        // ✅ Create a downloadable link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        showToast.success("Subscribers exported successfully");
      }
    } catch (error) {
      let errorMsg = "An error occurred while exporting subscribers";
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          if (json.message) errorMsg = json.message;
        } catch (_) {}
      } else if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      }
      console.log(error.response?.data || "Unknown error");
      showToast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCampaignExport = async ({ startLimit, endLimit }) => {
    const filterParams = {};

    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.screated_on = joinDateFilter[0];
    if (joinDateFilter[0] && joinDateFilter[1])
      filterParams.ecreated_on = joinDateFilter[1];
    if (uidFilter) filterParams.subscriberid = uidFilter;
    if (leadSourceFilter) filterParams.lead_source = leadSourceFilter;
    if (nameFilter) filterParams.fullname = nameFilter;
    if (mobileFilter) filterParams.mobileno = mobileFilter;
    if (altMobileFilter) filterParams.otherphone = altMobileFilter;
    if (emailFilter) filterParams.email = emailFilter;
    if (
      aiTagFilter &&
      (Array.isArray(aiTagFilter)
        ? aiTagFilter.length > 0
        : String(aiTagFilter).trim() !== "")
    )
      filterParams.ai_tag = Array.isArray(aiTagFilter)
        ? aiTagFilter.join(",")
        : aiTagFilter;
    if (stateFilter) filterParams.state = stateFilter;
    if (invCapitalFilter) filterParams.inv_capital = invCapitalFilter;
    if (leadStatusFilter && leadStatusFilter.length > 0)
      filterParams.lead_status = leadStatusFilter.join(",");
    if (expInMarketFilter) filterParams.exp_in_market = expInMarketFilter;
    if (investmentStatusFilter)
      filterParams.investments = investmentStatusFilter;
    if (convertibleFilter) filterParams.convertible = convertibleFilter;
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.srecent_contacted = recentContactedDateFilter[0];
    if (recentContactedDateFilter[0] && recentContactedDateFilter[1])
      filterParams.erecent_contacted = recentContactedDateFilter[1];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.snext_followup = followUpDateFilter[0];
    if (followUpDateFilter[0] && followUpDateFilter[1])
      filterParams.enext_followup = followUpDateFilter[1];
    if (languageFilter) filterParams.language = languageFilter;
    if (clientStatusFilter && clientStatusFilter.length > 0)
      filterParams.client_status = clientStatusFilter.join(",");
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.ssubscribed_on = subscribedDateFilter[0];
    if (subscribedDateFilter[0] && subscribedDateFilter[1])
      filterParams.esubscribed_on = subscribedDateFilter[1];
    if (subscriberStatusFilter && subscriberStatusFilter.length > 0)
      filterParams.status = subscriberStatusFilter.join(",");
    if (assignedToFilter) filterParams.assignedto = assignedToFilter;
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.supdated_on = updatedOnDateFilter[0];
    if (updatedOnDateFilter[0] && updatedOnDateFilter[1])
      filterParams.eupdated_on = updatedOnDateFilter[1];
    if (updatedByFilter) filterParams.updated_by = updatedByFilter;
    if (deviceIdFilter) filterParams.deviceid = deviceIdFilter;
    if (utmSourceFilter) filterParams.utm_source = utmSourceFilter;
    if (utmMediumFilter) filterParams.utm_medium = utmMediumFilter;
    if (utmCampaignFilter) filterParams.utm_campaign = utmCampaignFilter;
    if (utmContentFilter) filterParams.utm_content = utmContentFilter;
    if (utmTermFilter) filterParams.utm_term = utmTermFilter;
    if (sortField) filterParams.orderbycol = sortField;
    if (sortOrder) filterParams.orderby = sortOrder;
    if (subscriptionAmountFilter) {
      const range = parseNumericRange(subscriptionAmountFilter);
      if (range.min !== undefined) filterParams.min_subscription_amount = range.min;
      if (range.max !== undefined) filterParams.max_subscription_amount = range.max;
    }
    if (firstAmountFilter) {
      const range = parseNumericRange(firstAmountFilter);
      if (range.min !== undefined) filterParams.min_first_amount = range.min;
      if (range.max !== undefined) filterParams.max_first_amount = range.max;
    }

    try {
      setLoading(true);

      // Build query parameters
      const queryParams = new URLSearchParams({
        checkAll: checkingAll.toString(),
      });

      // Add startLimit and endLimit if provided
      if (startLimit !== undefined && startLimit !== "") {
        queryParams.append("startlimit", startLimit);
      }
      if (endLimit !== undefined && endLimit !== "") {
        queryParams.append("endlimit", endLimit);
      }

      const response = await axios.post(
        `${API_URL}subscriber/campaign-export?${queryParams.toString()}`,
        {
          selectedIds: checkingAll ? [] : selectedSubscribers,
          filters: checkingAll ? filterParams : {},
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      if (response.status == 200 || response.status == 201) {
        const now = new Date();
        const formattedDate = now
          .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })
          .replace(/[/, ]+/g, "_");

        const fileName = `CampaignExport-${formattedDate}.xlsx`;

        // ✅ Create a downloadable link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        showToast.success("Campaign export completed successfully");

        // Close modal after successful export
        setIsCampaignExportOpen(false);
      }
    } catch (error) {
      let errorMsg = "An error occurred while exporting campaign data";
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          if (json.message) errorMsg = json.message;
        } catch (_) {}
      } else if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      }
      console.log(error.response?.data || "Unknown error");
      showToast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadSample = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("authToken");

      // ✅ API is GET (no body, only headers + params)
      const response = await axios.get(`${API_URL}subscriber/download-sample`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          checkAll: checkingAll,
          selectedIds: selectedSubscribers?.join(","), // send as query param if backend supports
          ...getCurrentFilterParams(), // spread filters into query params
        },
        responseType: "blob", // Important for file downloads
      });

      // Create a timestamp for the filename
      const now = new Date();
      const formattedDate = now
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .replace(/[/, ]+/g, "_");

      const fileName = `SubscriberImportSample_${formattedDate}.xlsx`;

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showToast.success("Sample file downloaded successfully");
    } catch (error) {
      console.error("Download error:", error);
      showToast.error("Failed to download sample file");
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get current filter parameters
  const getCurrentFilterParams = () => {
    return buildFilterParams();
  };

  // Close the modal
  const closeModal = () => {
    setIsModalOpenSubscriber(false);
    setIsModalOpenFreeService(false);
    setIsModalOpenStreetStocks(false);
    setIsModalOpenSendPushNotification(false);
    setisModalOpenSendSms(false);
    setMessage("");
    setMessageType("");
    setFormData({
      fullname: "",
      mobileno: "",
      email: "",
      lead_source: "",
      language: "",
    });
    setServiceData({
      fullname: "",
      mobileno: "",
      email: "",
      languageid: "",
      serviceid: "",
      stype: "Free",
      tradesTotal: 0,
    });
    setSendPushData({
      title: "",
      pushTemplate: "",
      message: "",
    });
    setSendSmsData({
      pushTemplate: "",
      message: "",
    });
    setSmsTemplateData({
      template: null,
    });
    setIsLoadingSmsTemplate(false);
  };

  // Toggle the modal open/close
  const toggleModal = () => {
    setIsModalOpenSubscriber(!isModalOpenSubscriber);
  };
  const toggleModalFreeService = () => {
    setIsModalOpenFreeService(!isModalOpenFreeService);
  };
  const toggleModalStreetStocks = () => {
    setIsModalOpenStreetStocks(!isModalOpenStreetStocks);
  };

  // Handle date picker change

  const handleJoinDateChange = (dates) => setJoinDateFilter(dates);
  const handleFollowUpDateChange = (dates) => setFollowUpDateFilter(dates);
  const handleSubscribedDateChange = (dates) => setSubscribedDateFilter(dates);
  const handleRecentContactedDateChange = (dates) =>
    setRecentContactedDateFilter(dates);
  const handleUpdatedOnDateChange = (dates) => setUpdatedOnDateFilter(dates);
  const handleTradeCreatedOnChange = (dates) => setTradeCreatedOnFilter(dates);
  const handleFolioCreatedOnChange = (dates) => setFolioCreatedOnFilter(dates);

  const clearMultipleSelectFilters = () => {
    setLeadStatusFilter([]);
    setClientStatusFilter([]);
    setSubscriberStatusFilter([]);
    setAiTagFilter([]);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= hasMoreData) {
      setPage(newPage);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalCount);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleMobileSearch = async () => {
    if (!mobileSearchInput.trim()) {
      setMobileSearchResult(null);
      return;
    }

    setIsSearchingMobile(true);
    try {
      const response = await axios.post(
        `${API_URL}subscriber/get-assigned-user`,
        {
          input: mobileSearchInput.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success && response.data.data) {
        setMobileSearchResult(response.data.data);
      } else {
        setMobileSearchResult(null);
      }
    } catch (error) {
      console.error("Mobile search error:", error);
      setMobileSearchResult(null);
    } finally {
      setIsSearchingMobile(false);
    }
  };

  // Handle mobile search input change
  const handleMobileSearchInputChange = (e) => {
    const value = e.target.value;
    setMobileSearchInput(value);

    // Clear search result when input is cleared
    if (!value.trim()) {
      setMobileSearchResult(null);
      setMobileFilter("");
      setEmailFilter("");
      handleSearch();
    }
  };

  // Handle mobile search submit - calls both the mobile search API and the table fetch
  const handleMobileSearchSubmit = () => {
    handleMobileSearch();

    // Also filter the table based on the search input
    const value = mobileSearchInput.trim();
    if (value) {
      if (value.includes("@")) {
        setEmailFilter(value);
        setMobileFilter("");
      } else {
        setMobileFilter(value);
        setEmailFilter("");
      }
      handleSearch();
    }
  };

  // Keep the existing mobileFilter for table filtering separate
  const handleMobileFilterChange = (e) => {
    const value = e.target.value;
    setMobileFilter(value);
  };

  function hasAnyFilter() {
    const filters = [
      // Date filters
      () => joinDateFilter[0] || joinDateFilter[1],
      () => recentContactedDateFilter[0] || recentContactedDateFilter[1],
      () => followUpDateFilter[0] || followUpDateFilter[1],
      () => subscribedDateFilter[0] || subscribedDateFilter[1],
      () => updatedOnDateFilter[0] || updatedOnDateFilter[1],
      () => tradeCreatedOnFilter[0] || tradeCreatedOnFilter[1],
      () => folioCreatedOnFilter[0] || folioCreatedOnFilter[1],

      // String filters
      () => uidFilter && uidFilter.toString().trim() !== "",
      () => leadSourceFilter && leadSourceFilter.toString().trim() !== "",
      () => nameFilter && nameFilter.toString().trim() !== "",
      () => mobileFilter && mobileFilter.toString().trim() !== "",
      () => altMobileFilter && altMobileFilter.toString().trim() !== "",
      () => emailFilter && emailFilter.toString().trim() !== "",
      () => stateFilter && stateFilter.toString().trim() !== "",
      () => invCapitalFilter && invCapitalFilter.toString().trim() !== "",
      () => expInMarketFilter && expInMarketFilter.toString().trim() !== "",
      () =>
        investmentStatusFilter &&
        investmentStatusFilter.toString().trim() !== "",
      () => convertibleFilter && convertibleFilter.toString().trim() !== "",
      () => languageFilter && languageFilter.toString().trim() !== "",
      () => assignedToFilter && assignedToFilter.toString().trim() !== "",
      () => updatedByFilter && updatedByFilter.toString().trim() !== "",
      () => deviceIdFilter && deviceIdFilter.toString().trim() !== "",
      () => utmSourceFilter && utmSourceFilter.toString().trim() !== "",
      () => utmMediumFilter && utmMediumFilter.toString().trim() !== "",
      () => utmCampaignFilter && utmCampaignFilter.toString().trim() !== "",
      () => utmContentFilter && utmContentFilter.toString().trim() !== "",
      () => utmTermFilter && utmTermFilter.toString().trim() !== "",
      () => categoryFilter && categoryFilter.toString().trim() !== "",
      () =>
        assignedToFolioFilter && assignedToFolioFilter.toString().trim() !== "",
      () =>
        assignedToResearchFilter && assignedToResearchFilter.toString().trim() !== "",
      () => inFolioFilter && inFolioFilter.toString().trim() !== "",
      () =>
        subscriptionAmountFilter &&
        subscriptionAmountFilter.toString().trim() !== "",
      () => firstAmountFilter && firstAmountFilter.toString().trim() !== "",

      // Array filters
      () => leadStatusFilter && leadStatusFilter.length > 0,
      () => clientStatusFilter && clientStatusFilter.length > 0,
      () => subscriberStatusFilter && subscriberStatusFilter.length > 0,
      () => aiTagFilter && aiTagFilter.length > 0,

      // Toggle filters
      () => emailFilterState !== 0,
      () => tradeFilter !== 0,
      () => streetfolioFilter !== 0,

      // Sort filters
      () => sortField && sortField.toString().trim() !== "",
      () => sortOrder && sortOrder.toString().trim() !== "",
      () => activeFilter === "Read" || activeFilter === "Unread",
    ];

    return filters.some((filter) => filter());
  }

  const handleCampaignSubmit = async ({
    templateId,
    channels,
    startLimit,
    endLimit,
    campaign_name,
  }) => {
    setCampaignLoading(true);
    try {
      const filterParams = hasAnyFilter() ? getCurrentFilterParams() : {};
      const payload = {
        selectedIds: checkingAll ? [] : selectedSubscribers,
        selectedChannels: channels,
        templateId,
        campaign_name:
          campaign_name !== undefined && campaign_name !== ""
            ? campaign_name
            : undefined,
        filters: checkingAll ? filterParams : {},
      };

      // Build query parameters
      const queryParams = new URLSearchParams({
        checkingAll: checkingAll.toString(),
      });

      // Add startLimit and endLimit if provided
      if (startLimit !== undefined && startLimit !== "") {
        queryParams.append("startlimit", startLimit);
      }
      if (endLimit !== undefined && endLimit !== "") {
        queryParams.append("endlimit", endLimit);
      }

      const response = await axios.post(
        `${API_URL}subscriber/saveBulkCampaign?${queryParams.toString()}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      showToast.success(response.data.message || "Campaign sent successfully");
      setIsCampaignModalOpen(false);
      setSelectedSubscribers([]);
      fetchUsers();
    } catch (error) {
      showToast.error("Failed to send campaign");
    } finally {
      setCampaignLoading(false);
    }
  };

  const handleBroadcastSubmit = async (broadcastData) => {
    try {
      setLoading(true);

      // Get filter parameters if checkingAll is true
      const filterParams = checkingAll ? getCurrentFilterParams() : {};

      // Prepare FormData as required by the API
      const formData = new FormData();

      // Add selected IDs (empty if checkingAll)
      formData.append(
        "selectedIds",
        checkingAll ? "" : selectedSubscribers.join(",")
      );

      // Add filters if checkingAll is true
      if (checkingAll && Object.keys(filterParams).length > 0) {
        formData.append("filters", JSON.stringify(filterParams));
      }

      // Add required fields
      formData.append("campaign_name", broadcastData.campaign_name);
      formData.append("templateId", broadcastData.template_id.toString());

      // Add image file
      if (broadcastData.image) {
        formData.append("imageUrl", broadcastData.image);
      }

      // Build query parameters
      const queryParams = new URLSearchParams({
        checkingAll: checkingAll.toString(),
      });

      // Add startlimit and endlimit if provided and checkingAll is true
      // if (checkingAll && broadcastData.startLimit) {
      //     queryParams.append("startlimit", broadcastData.startLimit);
      // }
      // if (checkingAll && broadcastData.endLimit) {
      //     queryParams.append("endlimit", broadcastData.endLimit);
      // }

      const response = await axios.post(
        `${API_URL}subscriber/save-broadcast?${queryParams.toString()}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success || response.status === 201) {
        showToast.success(
          response.data.message || "Broadcast sent successfully"
        );
        setIsBroadcastModalOpen(false);
        setSelectedSubscribers([]);
        // Optional: Refresh the data
        fetchUsers();
      } else {
        showToast.error(response.data.message || "Failed to send broadcast");
      }
    } catch (error) {
      console.error("Broadcast error:", error);
      showToast.error(
        error.response?.data?.message || "Error sending broadcast"
      );
    } finally {
      setLoading(false);
    }
  };

  // Calculate total subscription amount
  // const totalSubscriptionAmount = filteredUsers.reduce((sum, user) => {
  //   const amount = parseFloat(user.subscription_amount) || 0;
  //   return sum + amount;
  // }, 0);

  return (
    <div className="panel-content mt-5 panel-content-responsive">
      <div className="panel-heading subscriber-header-container pl-0 pr-0">
        <div className="header-action-search-row">
          <div className="action-button-container" ref={actionMenuRef}>
            <div className="desktop-action-wrapper">
              <select
                value="" // No value needed for action dropdown
                onChange={(e) => {
                  const selectedAction = e.target.value;
                  if (selectedAction) {
                    handleActionChange(selectedAction);
                  }
                }}
                className="action-select-box"
              >
                <option value="">Action</option>
                <PermissionWrapper module="subscriber" action="delete">
                  <option value="delete">Delete Subscriber</option>
                </PermissionWrapper>
                <PermissionWrapper module="subscriber" action="edit">
                  <option value="bulkEdit">Bulk Edit</option>
                </PermissionWrapper>
                <PermissionWrapper module="subscriber" action="export">
                  <option value="bulkExport">Bulk Export Data</option>
                </PermissionWrapper>
                <PermissionWrapper module="subscriber" action="import">
                  <option value="bulkImport">Bulk Import Data</option>
                </PermissionWrapper>
                <FieldPermissionWrapper field="bulk_campaign">
                  <option value="campaign">Campaign</option>
                </FieldPermissionWrapper>
                <option value="aiCallCampaign">AI Call Campaign</option>
                <option value="aiSarvamCampaign">Sarvam AI Campaign</option>
                <PermissionWrapper module="subscriber" action="export">
                  <option value="campaignExport">Campaign Export</option>
                </PermissionWrapper>
                <FieldPermissionWrapper field="bulk_broadcast">
                  <option value="broadcast">Broadcast</option>
                </FieldPermissionWrapper>
              </select>
            </div>

            <div className="mobile-action-dots-wrapper">
              <button
                className="btn btn-default btn-xs mobile-dots-btn"
                onClick={() => setIsActionMenuOpen(!isActionMenuOpen)}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} /> Action
              </button>
              {isActionMenuOpen && (
                <div className="mobile-action-dropdown">
                  <PermissionWrapper module="subscriber" action="delete">
                    <div className="action-item" onClick={() => { handleActionChange("delete"); setIsActionMenuOpen(false); }}>Delete Subscriber</div>
                  </PermissionWrapper>
                  <PermissionWrapper module="subscriber" action="edit">
                    <div className="action-item" onClick={() => { handleActionChange("bulkEdit"); setIsActionMenuOpen(false); }}>Bulk Edit</div>
                  </PermissionWrapper>
                  <PermissionWrapper module="subscriber" action="export">
                    <div className="action-item" onClick={() => { handleActionChange("bulkExport"); setIsActionMenuOpen(false); }}>Bulk Export Data</div>
                  </PermissionWrapper>
                  <PermissionWrapper module="subscriber" action="import">
                    <div className="action-item" onClick={() => { handleActionChange("bulkImport"); setIsActionMenuOpen(false); }}>Bulk Import Data</div>
                  </PermissionWrapper>
                  <FieldPermissionWrapper field="bulk_campaign">
                    <div className="action-item" onClick={() => { handleActionChange("campaign"); setIsActionMenuOpen(false); }}>Campaign</div>
                  </FieldPermissionWrapper>
                  <div className="action-item" onClick={() => { handleActionChange("aiCallCampaign"); setIsActionMenuOpen(false); }}>AI Call Campaign</div>
                  <div className="action-item" onClick={() => { handleActionChange("aiSarvamCampaign"); setIsActionMenuOpen(false); }}>Sarvam AI Campaign</div>
                  <PermissionWrapper module="subscriber" action="export">
                    <div className="action-item" onClick={() => { handleActionChange("campaignExport"); setIsActionMenuOpen(false); }}>Campaign Export</div>
                  </PermissionWrapper>
                  <FieldPermissionWrapper field="bulk_broadcast">

                    <div className="action-item" onClick={() => { handleActionChange("broadcast"); setIsActionMenuOpen(false); }}>Broadcast</div>
                  </FieldPermissionWrapper>
                </div>
              )}
            </div>
          </div>

          <div className="search-container-wrapper">
            {(hasPermission("subscriber_mobileno", "view") ||
              hasPermission("subscriber_email", "view")) && (
                <div className="search-box-flex">
                  <input
                    type="text"
                    name="search_mob"
                    id="search_mob"
                    placeholder={
                      hasPermission("subscriber_mobileno", "view") &&
                        hasPermission("subscriber_email", "view")
                        ? "Enter Mobile No./Email ID"
                        : hasPermission("subscriber_mobileno", "view")
                          ? "Enter Mobile No."
                          : "Enter Email ID"
                    }
                    className="form-control subscriber-search-input"
                    value={mobileSearchInput}
                    onChange={handleMobileSearchInputChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleMobileSearchSubmit();
                      }
                    }}
                    disabled={
                      !hasPermission("subscriber_mobileno", "view") &&
                      !hasPermission("subscriber_email", "view")
                    }
                  />
                  <button
                    className="btn btn-default btn-sm search-submit-btn"
                    onClick={handleMobileSearchSubmit}
                    disabled={
                      isSearchingMobile ||
                      (!hasPermission("subscriber_mobileno", "view") &&
                        !hasPermission("subscriber_email", "view"))
                    }
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                  {hasAnyFilter() && (
                    <button
                      className="btn btn-default btn-xs clear-filters-btn"
                      onClick={clearAllFilters}
                      title="Clear all filters"
                    >
                      Clear
                    </button>
                  )}
                </div>
              )}
          </div>
        </div>

        <div className="header-pagination-add-row">
          <div className="pagination-controls-wrapper">
            <span className="pagination-status-text">
              {loading ? (
                <span className="skeleton-text" style={{ width: "100px" }}></span>
              ) : (
                `${start} to ${end} of ${totalCount}`
              )}
            </span>
            <button
              className="btn btn-default btn-xs ms-1"
              onClick={() => handleSearch()}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </button>
            <div className="pagination-nav-buttons">
              <button
                className={`btn btn-default btn-sm nav-prev-btn ${page === 1 ? "d-none" : ""}`}
                title="Previous"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <button
                className={`btn btn-default btn-sm nav-next-btn ${page === hasMoreData ? "d-none" : ""}`}
                title="Next"
                onClick={() => handlePageChange(page + 1)}
                disabled={page === hasMoreData}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          <div className="add-subscriber-buttons-wrapper">
            <PermissionWrapper module="subscriber" action="add">
              <button
                className="btn btn-default btn-sm add-sub-btn"
                onClick={toggleModal}
              >
                <FontAwesomeIcon icon={faPlus} /> Add Subscriber
              </button>
            </PermissionWrapper>
            <PermissionWrapper module="subscriber" action="add">
              <button
                className="btn btn-default btn-sm add-service-btn"
                onClick={toggleModalFreeService}
              >
                <FontAwesomeIcon icon={faPlus} /> Add Free Service
              </button>
            </PermissionWrapper>
          </div>
        </div>
      </div>
      {/* Mobile Search Results - Display below action buttons */}
      {mobileSearchResult && (
        <div className="row mb-3">
          <div className="col-md-12">
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="ms-4">
                  <strong>Results : </strong>
                  {!mobileSearchResult.user_name &&
                    !mobileSearchResult.subscribername &&
                    !mobileSearchResult.subscriberid ? (
                    <span className="">Subscriber not found</span>
                  ) : (
                    <>
                      <span className="">{mobileSearchResult.user_name}</span>
                      <span className="mx-2">›</span>
                      <span className="">
                        {mobileSearchResult.subscribername}
                      </span>
                    </>
                  )}
                </div>
                {/* <div>
            <span className="badge bg-secondary">
              ID: {mobileSearchResult.subscriberid}
            </span>
          </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="large-table-container-3">
          <div
            ref={topScrollRef}
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              height: "16px",
              // width: "100%",
              marginBottom: "2px",
              background: "#f8f9fa",
            }}
          >
            {/* This inner div's width should match the table's width */}
            <div style={{ width: "100%", height: "1px" }}></div>
          </div>
          <div
            ref={tableContainerRef}
            // style={{
            //   overflowY: "auto",
            //   maxHeight: "400px",
            //   overflowX: "auto", // For horizontal scrolling
            //   // position: "sticky",
            //   // top: 0,
            //   // zIndex: 10,
            // }}
            style={{
              overflowY: "auto",
              height: "calc(112vh - 250px)",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <div className="d-flex justify-content-center">
              <button
                className={`btn ${checkingAll ? "btn-primary" : "btn-default"
                  } btn-xs ${showSelectAllButton || checkingAll ? "d-block" : "d-none"
                  }`}
                onClick={toggleCheckingAll}
              >
                {checkingAll
                  ? "All records are selected"
                  : "Select All the Records"}
              </button>
            </div>

            <table className="table table-condensed table-hover bg-white sticky-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          const allIds = filteredUsers.map((user) => user.id);
                          setSelectedSubscribers(allIds);
                          setCheckingAll(false); // Reset checkingAll when manually selecting
                        } else {
                          setSelectedSubscribers([]);
                          setCheckingAll(false); // Reset checkingAll when deselecting
                        }
                      }}
                      checked={
                        checkingAll ||
                        (filteredUsers.length > 0 &&
                          selectedSubscribers.length === filteredUsers.length)
                      }
                    />
                  </th>
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => sortBox("created_on")}
                  >
                    Created Time{" "}
                    <FontAwesomeIcon icon={getSortIcon("created_on")} />
                  </th>
                  <FieldPermissionWrapper field="subscriber_id">
                    <th
                      className={getFirstStickyColumnClass()}
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("subscriberid")}
                    >
                      Sub Uid{" "}
                      <FontAwesomeIcon icon={getSortIcon("subscriberid")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_source">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("lead_source")}
                    >
                      Lead Source{" "}
                      <FontAwesomeIcon icon={getSortIcon("lead_source")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_fullname">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("fullname")}
                    >
                      Name <FontAwesomeIcon icon={getSortIcon("fullname")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_mobileno">
                    <th className={getMobileColumnClass()}>Mobile No</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_otherphone">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("otherphone")}
                    >
                      Alternate No.{" "}
                      <FontAwesomeIcon icon={getSortIcon("otherphone")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_email">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("email")}
                    >
                      Email <FontAwesomeIcon icon={getSortIcon("email")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_ai_tag">
                    <th
                      style={{ cursor: "pointer", minWidth: "125px" }}
                      onClick={() => sortBox("ai_tag")}
                    >
                      AI Tag <FontAwesomeIcon icon={getSortIcon("ai_tag")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_state">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("state")}
                    >
                      State <FontAwesomeIcon icon={getSortIcon("state")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="service_category">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("source")}
                    >
                      Category <FontAwesomeIcon icon={getSortIcon("source")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th style={{ minWidth: "80px" }}>Trades</th>
                  <FieldPermissionWrapper field="subscriber_trade_created_on">
                    <th
                      style={{ cursor: "pointer", minWidth: "155px" }}
                      onClick={() => sortBox("trade_created_on")}
                    >
                      Trade Created On{" "}
                      <FontAwesomeIcon icon={getSortIcon("trade_created_on")} />
                    </th>
                  </FieldPermissionWrapper>
                  {/* Add Streetfolio column */}
                  <FieldPermissionWrapper field="subscriber_in_folio">
                    <th style={{ minWidth: "80px" }}>Folios</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_folio_created_on">
                    <th
                      style={{ cursor: "pointer", minWidth: "155px" }}
                      onClick={() => sortBox("folio_created_on")}
                    >
                      Folio Created On{" "}
                      <FontAwesomeIcon icon={getSortIcon("folio_created_on")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_in_folio">
                    <th
                      style={{ cursor: "pointer", minWidth: "160px" }}
                      onClick={() => sortBox("in_folio")}
                    >
                      Interested In Streetfolio{" "}
                      <FontAwesomeIcon icon={getSortIcon("in_folio")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_inv_capital">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("inv_capital")}
                    >
                      Inv. Capital{" "}
                      <FontAwesomeIcon icon={getSortIcon("inv_capital")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_status">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("lead_status")}
                    >
                      Lead Status{" "}
                      <FontAwesomeIcon icon={getSortIcon("lead_status")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_exp_in_market">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("exp_in_market")}
                    >
                      Exp. In Markets{" "}
                      <FontAwesomeIcon icon={getSortIcon("exp_in_market")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_investments">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("investments")}
                    >
                      Investments{" "}
                      <FontAwesomeIcon icon={getSortIcon("investments")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_convertible">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("convertible")}
                    >
                      Convertible{" "}
                      <FontAwesomeIcon icon={getSortIcon("convertible")} />
                    </th>
                  </FieldPermissionWrapper>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => sortBox("recent_contacted")}
                  >
                    Recent Contacted{" "}
                    <FontAwesomeIcon icon={getSortIcon("recent_contacted")} />
                  </th>
                  <FieldPermissionWrapper field="subscriber_next_followup">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("next_followup")}
                    >
                      Followup Date{" "}
                      <FontAwesomeIcon icon={getSortIcon("next_followup")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_language">
                    <th>Language</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_client_status">
                    <th>Client Status</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("subscribed_on")}
                    >
                      Subscribed On{" "}
                      <FontAwesomeIcon icon={getSortIcon("subscribed_on")} />
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("subscribed_days")}
                    >
                      ConDays{" "}
                      <FontAwesomeIcon icon={getSortIcon("subscribed_days")} />
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("active_days")}
                    >
                      Active Days{" "}
                      <FontAwesomeIcon icon={getSortIcon("active_days")} />
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("subscription_amount")}
                    >
                      Subscription Amount{" "}
                      <FontAwesomeIcon
                        icon={getSortIcon("subscription_amount")}
                      />
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("first_amount")}
                    >
                      First Amount{" "}
                      <FontAwesomeIcon
                        icon={getSortIcon("first_amount")}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  {/* <FieldPermissionWrapper field="subscriber_status">
                    <th>Status</th>
                  </FieldPermissionWrapper> */}
                  <FieldPermissionWrapper field="subscriber_assignedtomenu">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("assignedto")}
                    >
                      Assign To{" "}
                      <FontAwesomeIcon icon={getSortIcon("assignedto")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_assigned_to_research">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("r_assigned")}
                    >
                      Assigned to Research{" "}
                      <FontAwesomeIcon icon={getSortIcon("r_assigned")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_askfps">
                    <th
                      style={{ cursor: "pointer", minWidth: "90px" }}
                      onClick={() => sortBox("askfps")}
                    >
                      Askfps{" "}
                      <FontAwesomeIcon icon={getSortIcon("askfps")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_en">
                    <th
                      style={{ cursor: "pointer", minWidth: "90px" }}
                      onClick={() => sortBox("lead_en")}
                    >
                      Leads{" "}
                      <FontAwesomeIcon icon={getSortIcon("lead_en")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_assignedto_folio">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("assignedto_folio")}
                    >
                      Folio Assign To{" "}
                      <FontAwesomeIcon icon={getSortIcon("assignedto_folio")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_modified_time">
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => sortBox("updated_on")}
                    >
                      Modified Time{" "}
                      <FontAwesomeIcon icon={getSortIcon("updated_on")} />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_updatedby">
                    <th>Modified By</th>
                  </FieldPermissionWrapper>
                  <th>Device ID</th>
                  <FieldPermissionWrapper field="subscriber_utmsource">
                    <th>UTM Source</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_utmmedium">
                    <th>UTM Medium</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_utmcampaign">
                    <th>UTM Campaign</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_utmcontent">
                    <th>UTM Content</th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_utmterm">
                    <th>UTM Term</th>
                  </FieldPermissionWrapper>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <div className="custom-datepicker-wrapper">
                        <DatePicker
                          portalId="datepicker-portal"
                          selected={joinDateFilter[0]}
                          onChange={handleJoinDateChange}
                          startDate={joinDateFilter[0]}
                          endDate={joinDateFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={joinDateFilter[0] || new Date()} // Open at selected date if exists, else today
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15} // Shows 15 years in dropdown
                          minDate={new Date(2018, 0, 1)} // Start from 2018
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy" // Display format
                        />
                      </div>

                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => handleSearch()}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>
                  <FieldPermissionWrapper field="subscriber_id">
                    <th className={getFirstStickyColumnClass()}>
                      <input
                        type="text"
                        placeholder=""
                        value={uidFilter}
                        onChange={(e) => setUidFilter(e.target.value)}
                        style={{
                          width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_source">
                    <th>
                      <select
                        value={leadSourceFilter}
                        onChange={(e) => setLeadSourceFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.leadSourceList &&
                          dropdownOptions.leadSourceList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_fullname">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={nameFilter}
                        onChange={(e) => setNameFilter(e.target.value)}
                        style={{
                          width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_mobileno">
                    <th className={getMobileColumnClass()}>
                      <input
                        type="text"
                        placeholder=""
                        value={mobileFilter}
                        onChange={(e) => setMobileFilter(e.target.value)}
                        style={{
                          width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_otherphone">
                    <th>
                      <input
                        type="text"
                        placeholder=""
                        value={altMobileFilter}
                        onChange={(e) => setAltMobileFilter(e.target.value)}
                        style={{
                          width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_email">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <input
                          type="email"
                          placeholder=""
                          value={emailFilter}
                          onChange={(e) => setEmailFilter(e.target.value)}
                          style={{
                            width: "90px",
                            padding: "5px",
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleSearch();
                          }}
                        />
                        {/* <button
                          type="button"
                          className={`btn ${isEmailFilterEnabled ? "btn-primary" : "btn-default"} btn-xs`}
                          title={isEmailFilterEnabled ? "Email filter ON" : "Email filter OFF"}
                          onClick={() => setIsEmailFilterEnabled((v) => !v)}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                        </button> */}
                        <button
                          type="button"
                          className={`btn btn-xs ${emailFilterState === 1
                            ? "btn-primary"
                            : emailFilterState === 2
                              ? "btn-success"
                              : "btn-default"
                            }`}
                          title={
                            emailFilterState === 1
                              ? "Email filter: has email (is_email=1)"
                              : emailFilterState === 2
                                ? "Email filter: no email (is_email=0)"
                                : "Email filter OFF"
                          }
                          onClick={toggleEmailFilter}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_ai_tag">
                    <th>
                      <MultiSelectDropdown
                        options={aiTagOptions}
                        selectedValues={
                          Array.isArray(aiTagFilter)
                            ? aiTagFilter
                            : aiTagFilter
                            ? [aiTagFilter]
                            : []
                        }
                        onChange={setAiTagFilter}
                        placeholder="--Select--"
                        onSearch={() => handleSearch()}
                        className="ai-tag-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_state">
                    <th>
                      <select
                        value={stateFilter}
                        onChange={(e) => setStateFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.stateList &&
                          dropdownOptions.stateList.map((item, index) => (
                            <option key={index} value={item.stateCode}>
                              {item.stateName}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="service_category">
                    <th>
                      <select
                        value={categoryFilter}
                        onChange={(e) => setCategoryFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.sourceList &&
                          dropdownOptions.sourceList.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  {/* Trade Filter */}
                  <th>
                    <button
                      type="button"
                      className="btn btn-xs btn-default"
                      title={
                        tradeFilter === 1
                          ? "Trade filter: trade active (istrade=1)"
                          : "Trade filter OFF"
                      }
                      onClick={toggleTradeFilter}
                    >
                      <FontAwesomeIcon
                        icon={faMobileAlt}
                        className={
                          tradeFilter === 1 ? "text-primary" : "text-secondary"
                        }
                      />
                    </button>
                  </th>
                  <FieldPermissionWrapper field="subscriber_trade_created_on">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          portalId="datepicker-portal"
                          selected={tradeCreatedOnFilter[0]}
                          onChange={handleTradeCreatedOnChange}
                          startDate={tradeCreatedOnFilter[0]}
                          endDate={tradeCreatedOnFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={tradeCreatedOnFilter[0] || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15}
                          minDate={new Date(2018, 0, 1)}
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy"
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => handleSearch()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>

                  {/* Streetfolio Filter */}
                  <FieldPermissionWrapper field="subscriber_in_folio">
                    <th>
                      <button
                        type="button"
                        className="btn btn-xs btn-default"
                        title={
                          streetfolioFilter === 1
                            ? "Streetfolio filter: streetfolio active (isfolio=1)"
                            : "Streetfolio filter OFF"
                        }
                        onClick={toggleStreetfolioFilter}
                      >
                        <FontAwesomeIcon
                          icon={faMobileAlt}
                          className={
                            streetfolioFilter === 1
                              ? "text-danger"
                              : "text-secondary"
                          }
                        />
                      </button>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_folio_created_on">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          portalId="datepicker-portal"
                          selected={folioCreatedOnFilter[0]}
                          onChange={handleFolioCreatedOnChange}
                          startDate={folioCreatedOnFilter[0]}
                          endDate={folioCreatedOnFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={folioCreatedOnFilter[0] || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15}
                          minDate={new Date(2018, 0, 1)}
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy"
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => handleSearch()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_in_folio">
                    <th>
                      <select
                        value={inFolioFilter}
                        onChange={(e) => {
                          setInFolioFilter(e.target.value);
                          setPage(1);
                        }}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        <option value="1">Interested</option>
                        <option value="0">Not Interested</option>
                      </select>
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_inv_capital">
                    <th>
                      <select
                        value={invCapitalFilter}
                        onChange={(e) => setInvCapitalFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.invCapitalList &&
                          dropdownOptions.invCapitalList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_status">
                    <th>
                      <MultiSelectDropdown
                        options={dropdownOptions.leadStatusList || []}
                        selectedValues={leadStatusFilter}
                        onChange={setLeadStatusFilter}
                        placeholder="--Select--"
                        // searchPlaceholder="Search lead status..."
                        onSearch={() => handleSearch()}
                        className="lead-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_exp_in_market">
                    <th>
                      <select
                        value={expInMarketFilter}
                        onChange={(e) => setExpInMarketFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.expInMarketList &&
                          dropdownOptions.expInMarketList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_investments">
                    <th>
                      <select
                        value={investmentStatusFilter}
                        onChange={(e) =>
                          setInvestmentStatusFilter(e.target.value)
                        }
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.investmentsList &&
                          dropdownOptions.investmentsList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_convertible">
                    <th>
                      <select
                        value={convertibleFilter}
                        onChange={(e) => setConvertibleFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.convertibleList &&
                          dropdownOptions.convertibleList.map((item, index) => (
                            <option key={index} value={item.pick_name}>
                              {item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={recentContactedDateFilter[0]}
                        onChange={handleRecentContactedDateChange}
                        startDate={recentContactedDateFilter[0]}
                        endDate={recentContactedDateFilter[1]}
                        selectsRange
                        isClearable
                        toggleCalendarOnIconClick
                        placeholderText=""
                        monthsShown={3}
                        openToDate={
                          recentContactedDateFilter[0] || new Date()
                        } // Open at selected date if exists, else today
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15} // Shows 15 years in dropdown
                        minDate={new Date(2018, 0, 1)} // Start from 2020
                        maxDate={new Date(2030, 11, 31)}
                        dateFormat="dd-MM-yyyy" // Display format
                      />
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => handleSearch()}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>
                  <FieldPermissionWrapper field="subscriber_next_followup">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          selected={followUpDateFilter[0]}
                          onChange={handleFollowUpDateChange}
                          startDate={followUpDateFilter[0]}
                          endDate={followUpDateFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={followUpDateFilter[0] || new Date()} // Open at selected date if exists, else today
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15} // Shows 15 years in dropdown
                          minDate={new Date(2018, 0, 1)} // Start from 2018
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy" // Display format
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => handleSearch()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_language">
                    <th>
                      <select
                        value={languageFilter}
                        onChange={(e) => setLanguageFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.languageList &&
                          dropdownOptions.languageList.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name || item.pick_name}
                            </option>
                          ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_client_status">
                    <th>
                      <MultiSelectDropdown
                        options={dropdownOptions.clientStatusList || []}
                        selectedValues={clientStatusFilter}
                        onChange={setClientStatusFilter}
                        placeholder="--Select--"
                        // searchPlaceholder="Search client status..."
                        onSearch={() => handleSearch()}
                        className="client-status-dropdown"
                      />
                    </th>
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          selected={subscribedDateFilter[0]}
                          onChange={handleSubscribedDateChange}
                          startDate={subscribedDateFilter[0]}
                          endDate={subscribedDateFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={subscribedDateFilter[0] || new Date()} // Open at selected date if exists, else today
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15} // Shows 15 years in dropdown
                          minDate={new Date(2018, 0, 1)} // Start from 2018
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy" // Display format
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => handleSearch()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 1000-50000"
                        title="Enter single value or range (e.g. 1000-50000, >=1000, <=50000)"
                        value={subscriptionAmountFilter}
                        onChange={(e) => setSubscriptionAmountFilter(e.target.value)}
                        style={{
                          width: "90px",
                          padding: "5px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        placeholder="e.g. 1000-50000"
                        title="Enter single value or range (e.g. 1000-50000, >=1000, <=50000)"
                        value={firstAmountFilter}
                        onChange={(e) => setFirstAmountFilter(e.target.value)}
                        style={{ width: "90px", padding: "5px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleSearch();
                        }}
                      />
                    </th>
                  </FieldPermissionWrapper>
                  {/* <FieldPermissionWrapper field="subscriber_status">
                    <th>
                      <MultiSelectDropdown
                        options={dropdownOptions.statusList || []}
                        selectedValues={subscriberStatusFilter}
                        onChange={setSubscriberStatusFilter}
                        placeholder="--Select--"
                        // searchPlaceholder="Search status..."
                        onSearch={() => handleSearch()}
                        className="subscriber-status-dropdown"
                      />
                    </th>
                  </FieldPermissionWrapper> */}
                  <FieldPermissionWrapper field="subscriber_assignedtomenu">
                    <th>
                      <select
                        value={assignedToFilter}
                        onChange={(e) => setAssignedToFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.assignedUserList &&
                          dropdownOptions.assignedUserList.map(
                            (item, index) => (
                              <option key={index} value={item.tu_id}>
                                {item.tu_user_fullname}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_assigned_to_research">
                    <th>
                      <select
                        value={assignedToResearchFilter}
                        onChange={(e) =>
                          setAssignedToResearchFilter(e.target.value)
                        }
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {(dropdownOptions.assignedResearchUserList?.length > 0
                          ? dropdownOptions.assignedResearchUserList
                          : dropdownOptions.assignedUserList || dropdownOptions.fullUserList || []
                        )?.map((item, index) => (
                          <option key={index} value={item.tu_id || item.id}>
                            {item.tu_user_fullname || item.user_fullname}
                          </option>
                        ))}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_askfps">
                    <th>
                      <select
                        value={askfpsFilter}
                        onChange={(e) => setAskfpsFilter(e.target.value)}
                        style={{ width: "80px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_lead_en">
                    <th>
                      <select
                        value={leadEnFilter}
                        onChange={(e) => setLeadEnFilter(e.target.value)}
                        style={{ width: "90px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        <option value="0">Existing</option>
                        <option value="1">New</option>
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_assignedto_folio">
                    <th>
                      <select
                        value={assignedToFolioFilter}
                        onChange={(e) =>
                          setAssignedToFolioFilter(e.target.value)
                        }
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.assignedUserList &&
                          dropdownOptions.assignedUserList.map(
                            (item, index) => (
                              <option key={index} value={item.tu_id}>
                                {item.tu_user_fullname}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_modified_time">
                    <th>
                      <div className="d-flex align-items-center gap-1">
                        <DatePicker
                          selected={updatedOnDateFilter[0]}
                          onChange={handleUpdatedOnDateChange}
                          startDate={updatedOnDateFilter[0]}
                          endDate={updatedOnDateFilter[1]}
                          selectsRange
                          isClearable
                          toggleCalendarOnIconClick
                          placeholderText=""
                          monthsShown={3}
                          openToDate={updatedOnDateFilter[0] || new Date()} // Open at selected date if exists, else today
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          scrollableYearDropdown
                          yearDropdownItemNumber={15} // Shows 15 years in dropdown
                          minDate={new Date(2018, 0, 1)} // Start from 2018
                          maxDate={new Date(2030, 11, 31)}
                          dateFormat="dd-MM-yyyy" // Display format
                        />
                        <button
                          type="button"
                          className="btn btn-default btn-xs btn-group-xs"
                          onClick={() => handleSearch()}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </div>
                    </th>
                  </FieldPermissionWrapper>
                  <FieldPermissionWrapper field="subscriber_updatedby">
                    <th>
                      <select
                        value={updatedByFilter}
                        onChange={(e) => setUpdatedByFilter(e.target.value)}
                        style={{ width: "110px", padding: "5px" }}
                      >
                        <option value="">--select--</option>
                        {dropdownOptions.updatedByUserList &&
                          dropdownOptions.updatedByUserList.map(
                            (item, index) => (
                              <option key={index} value={item.id}>
                                {item.user_fullname}
                              </option>
                            )
                          )}
                      </select>
                    </th>
                  </FieldPermissionWrapper>
                  <th>
                    <input
                      type="text"
                      placeholder=""
                      value={deviceIdFilter}
                      onChange={(e) => setDeviceIdFilter(e.target.value)}
                      style={{
                        width: "110px",
                        padding: "5px",
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearch();
                      }}
                    />
                  </th>
                  <FieldPermissionWrapper field="subscriber_utmsource">
                    <th style={{ minWidth: "120px" }}>
                      <Select
                        styles={customSelectStyles}
                        value={utmSourceFilter ? { value: utmSourceFilter, label: utmSourceFilter } : null}
                        onChange={(selectedOption) => setUtmSourceFilter(selectedOption ? selectedOption.value : "")}
                        options={(dropdownOptions.utmSourceList || []).map(item => ({ value: item, label: item }))}
                        isSearchable={true}
                        placeholder="--select--"
                        isClearable={true}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_utmmedium">
                    <th style={{ minWidth: "120px" }}>
                      <Select
                        styles={customSelectStyles}
                        value={utmMediumFilter ? { value: utmMediumFilter, label: utmMediumFilter } : null}
                        onChange={(selectedOption) => setUtmMediumFilter(selectedOption ? selectedOption.value : "")}
                        options={(dropdownOptions.utmMediumList || []).map(item => ({ value: item, label: item }))}
                        isSearchable={true}
                        placeholder="--select--"
                        isClearable={true}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_utmcampaign">
                    <th style={{ minWidth: "120px" }}>
                      <Select
                        styles={customSelectStyles}
                        value={utmCampaignFilter ? { value: utmCampaignFilter, label: utmCampaignFilter } : null}
                        onChange={(selectedOption) => setUtmCampaignFilter(selectedOption ? selectedOption.value : "")}
                        options={(dropdownOptions.utmCampaignList || []).map(item => ({ value: item, label: item }))}
                        isSearchable={true}
                        placeholder="--select--"
                        isClearable={true}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_utmcontent">
                    <th style={{ minWidth: "120px" }}>
                      <Select
                        styles={customSelectStyles}
                        value={utmContentFilter ? { value: utmContentFilter, label: utmContentFilter } : null}
                        onChange={(selectedOption) => setUtmContentFilter(selectedOption ? selectedOption.value : "")}
                        options={(dropdownOptions.utmContentList || []).map(item => ({ value: item, label: item }))}
                        isSearchable={true}
                        placeholder="--select--"
                        isClearable={true}
                      />
                    </th>
                  </FieldPermissionWrapper>

                  <FieldPermissionWrapper field="subscriber_utmterm">
                    <th style={{ minWidth: "120px" }}>
                      <Select
                        styles={customSelectStyles}
                        value={utmTermFilter ? { value: utmTermFilter, label: utmTermFilter } : null}
                        onChange={(selectedOption) => setUtmTermFilter(selectedOption ? selectedOption.value : "")}
                        options={(dropdownOptions.utmTermList || []).map(item => ({ value: item, label: item }))}
                        isSearchable={true}
                        placeholder="--select--"
                        isClearable={true}
                      />
                    </th>
                  </FieldPermissionWrapper>

                </tr>
              </thead>
              <tbody>
                {(loading || isRendering) ? (
                  // Show skeleton rows when loading
                  Array.from({ length: 10 }).map((_, skeletonIndex) => (
                    <tr
                      key={`skeleton-${skeletonIndex}`}
                      className="skeleton-row"
                    >
                      <td>
                        <div className="skeleton-checkbox"></div>
                      </td>
                      <td>
                        <div className="skeleton-text" style={{ width: "80%" }}></div>
                      </td>
                      <FieldPermissionWrapper field="subscriber_id">
                        <td className={getFirstStickyColumnClass()}>
                          <div className="skeleton-text" style={{ width: "70%" }}></div>
                        </td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_lead_source">
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_fullname">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_mobileno">
                        <td className={getMobileColumnClass()}>
                          <div className="skeleton-text" style={{ width: "75%" }}></div>
                        </td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_otherphone">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_email">
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_state">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="service_category">
                        <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      </FieldPermissionWrapper>
                      <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      <FieldPermissionWrapper field="subscriber_trade_created_on">
                        <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_in_folio">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_folio_created_on">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_in_folio">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_inv_capital">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_lead_status">
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_exp_in_market">
                        <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_investments">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_convertible">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper>
                      <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      <FieldPermissionWrapper field="subscriber_next_followup">
                        <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_language">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_client_status">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                        <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      {/* <FieldPermissionWrapper field="subscriber_status">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper> */}
                      <FieldPermissionWrapper field="subscriber_assignedtomenu">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_assigned_to_research">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_askfps">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_lead_en">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_assignedto_folio">
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_modified_time">
                        <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_updatedby">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      <FieldPermissionWrapper field="subscriber_utmsource">
                        <td><div className="skeleton-text" style={{ width: "90%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_utmmedium">
                        <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_utmcampaign">
                        <td><div className="skeleton-text" style={{ width: "80%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_utmcontent">
                        <td><div className="skeleton-text" style={{ width: "85%" }}></div></td>
                      </FieldPermissionWrapper>
                      <FieldPermissionWrapper field="subscriber_utmterm">
                        <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      </FieldPermissionWrapper>
                    </tr>
                  ))
                ) : (
                  // Show actual data when not loading
                  filteredUsers.map((user) => {
                    const isUnread =
                      user.is_folio_read === 0 || user.isRead === 0;
                    return (
                      <tr
                        key={user.id}
                        // className={
                        //   user.isRead === 1 ? "read-subscriber" : "unread-subscriber" // isRead: 0 = unread, 1 = read
                        // }
                        className={
                          isUnread ? "unread-subscriber" : "read-subscriber"
                        }
                        onClick={() => handleRowClick(user.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={
                              checkingAll ||
                              selectedSubscribers.includes(user.id)
                            }
                            onChange={(e) =>
                              handleCheckboxChange(user.id, e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {moment(user.created_on).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </td>
                        <FieldPermissionWrapper field="subscriber_id">
                          <td className={getFirstStickyColumnClass()}>
                            {user.subscriberid}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_lead_source">
                          {/* <td>{user.lead_source}</td> */}
                          <td>
                            {dropdownOptions.leadSourceList.find(
                              (source) =>
                                source.id === parseInt(user.lead_source)
                            )?.pick_name || user.lead_source}
                          </td>
                        </FieldPermissionWrapper>
                        {/* <FieldPermissionWrapper field="subscriber_fullname">
                        <td
                          style={{ cursor: "pointer" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.textDecoration = "underline")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.textDecoration = "none")
                          }
                        >
                          <a
                            href={`/Subscriber/Edit/${user?.id || "#"}`}
                            onClick={(e) => {
                              // Prevent full page reload and use navigate instead
                              e.preventDefault();
                              e.stopPropagation();

                              const sid = user?.id;
                              if (sid) {
                                navigate(`/Subscriber/Edit/${sid}`);
                              } else {
                                showToast.warning(
                                  "Subscriber ID not found for this record"
                                );
                              }
                            }}
                            style={{
                              color: "#0d6efd",
                              textDecoration: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "86%",
                            }}
                          >
                            <span>
                              {user.fullname}{" "}
                              {user.subscriberCount !== undefined &&
                                `(${user.subscriberCount})`}
                            </span>

                            {user.verifyuser === 1 && (
                              <div className="d-flex align-items-center gap-2">
                                <FontAwesomeIcon
                                  icon={faIdCard}
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "1.3rem",
                                  }}
                                  className="text-success"
                                />
                                <img
                                  src={bluetick}
                                  style={{ width: "15px", height: "15px" }}
                                  alt="Verified"
                                />
                              </div>
                            )}
                          </a>
                        </td>
                      </FieldPermissionWrapper> */}
                        <FieldPermissionWrapper field="subscriber_fullname">
                          <td
                            style={{
                              cursor: "pointer",
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.fullname}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration = "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                          >
                            <a
                              href={`/Subscriber/Edit/${user?.id || "#"}`}
                              onClick={(e) => {
                                // Prevent full page reload and use navigate instead
                                e.preventDefault();
                                e.stopPropagation();

                                const sid = user?.id;
                                if (sid) {
                                  const filterParams = buildFilterParams();
                                  filterParams.currentPage = page;
                                  filterParams.limit = limit;
                                  saveFilterParams(filterParams);

                                  navigate(`/Subscriber/Edit/${sid}`, {
                                    state: {
                                      filterParams,
                                      userData: user,
                                    },
                                  });
                                } else {
                                  showToast.warning(
                                    "Subscriber ID not found for this record"
                                  );
                                }
                              }}
                              style={{
                                color: "#0d6efd",
                                textDecoration: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "75%",
                                overflow: "hidden",
                              }}
                            >
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  flex: 1,
                                  marginRight: "8px",
                                }}
                              >
                                {user.fullname}{" "}
                                {user.subscriberCount !== undefined &&
                                  `(${user.subscriberCount})`}
                              </span>

                              {user.verifyuser === 1 && (
                                <div
                                  className="d-flex align-items-center gap-2"
                                  style={{ flexShrink: 0 }}
                                >
                                  <FontAwesomeIcon
                                    icon={faIdCard}
                                    style={{
                                      fontSize: "16px",
                                      lineHeight: "1.3rem",
                                    }}
                                    className="text-success"
                                  />
                                  <img
                                    src={bluetick}
                                    style={{ width: "15px", height: "15px" }}
                                    alt="Verified"
                                  />
                                </div>
                              )}
                              {user.ai_tag && (
                                <span
                                  title={`AI Called: ${user.ai_tag}`}
                                  style={{ flexShrink: 0, marginLeft: "4px" }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <FontAwesomeIcon
                                    icon={faRobot}
                                    style={{ fontSize: "15px", color: "#6f42c1" }}
                                  />
                                </span>
                              )}
                              {/* {user.compliance_score !== undefined && user.compliance_score !== null && String(user.compliance_score) !== "" && user.compliance_score != 0 && (
                                <span
                                  className={(user.compliance_score === "Red Flag" || user.compliance_score == -1) ? "d-inline-flex align-items-center justify-content-center" : "badge rounded-circle d-inline-flex align-items-center justify-content-center shadow-sm"}
                                  style={{
                                    width: '22px',
                                    height: '22px',
                                    marginLeft: '10px',
                                    backgroundColor: 'transparent',
                                    border: (user.compliance_score === "Red Flag" || user.compliance_score == -1) ? 'none' : '1px solid #28a745',
                                    color: (user.compliance_score === "Red Flag" || user.compliance_score == -1) ? '#dc3545' : '#28a745',
                                    verticalAlign: 'middle',
                                    fontSize: (user.compliance_score === "Red Flag" || user.compliance_score == -1) ? '1rem' : '0.6rem',
                                    flexShrink: 0
                                  }}
                                  title="Compliance Score"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {user.compliance_score === "Red Flag" || user.compliance_score == -1 ? <FontAwesomeIcon icon={faFlag} /> : `${user.compliance_score}%`}
                                </span>
                              )} */}
                            </a>
                          </td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_mobileno">
                          <td className={getMobileColumnClass()}>
                            {user.mobileno}
                            {/* {user.mobileno && (
                              <button
                                type="button"
                                className="btn btn-default btn-xs ms-1"
                                title="AI Voice Call & Logs"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedSubscriberForAiCall(user);
                                  setIsAiVoiceCallModalOpen(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faHeadset} /> Call
                              </button>
                            )} */}
                          </td>
                        </FieldPermissionWrapper>

                        <FieldPermissionWrapper field="subscriber_otherphone">
                          <td>{user.otherphone}</td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_email">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.email}
                          >
                            {user.email}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_ai_tag">
                          <td
                            style={{
                              maxWidth: "110px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.ai_tag || ""}
                          >
                            {user.ai_tag ? (
                              <span
                                className={`badge ${
                                  user.ai_tag === "Hot"
                                    ? "bg-success"
                                    : user.ai_tag === "Value"
                                    ? "bg-primary"
                                    : user.ai_tag === "Warm"
                                    ? "bg-warning text-dark"
                                    : user.ai_tag === "Escalate" || (user.ai_tag && user.ai_tag.includes("DND"))
                                    ? "bg-danger"
                                    : "bg-info text-dark"
                                }`}
                              >
                                {user.ai_tag}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_state">
                          {/* <td>{user.state}</td> */}
                          <td>
                            {dropdownOptions.stateList.find(
                              (state) =>
                                state.stateCode === parseInt(user.state)
                            )?.stateName || user.state}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="service_category">
                          <td>
                            {dropdownOptions.sourceList?.find(
                              (source) =>
                                source.value === parseInt(user.source)
                            )?.label || "N/A"}
                          </td>
                        </FieldPermissionWrapper>
                        <td>
                          {user.istrade === 1 &&
                            // <FontAwesomeIcon
                            //   icon={faMobileAlt}
                            //   className="text-primary"
                            //   style={{
                            //     fontSize: "1rem",
                            //     lineHeight: "1rem",
                            //   }}
                            //   title="Trade active"
                            // />
                            "Y"}
                        </td>
                        <FieldPermissionWrapper field="subscriber_trade_created_on">
                          <td>
                            {user.trade_created_on
                              ? moment(user.trade_created_on).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                              : ""}
                          </td>
                        </FieldPermissionWrapper>
                        {/* Streetfolio Display Column */}
                        <FieldPermissionWrapper field="subscriber_in_folio">
                          <td>
                            {user.isfolio === 1 &&
                              // <FontAwesomeIcon
                              //   icon={faMobileAlt}
                              //   className="text-danger"
                              //   style={{
                              //     fontSize: "1rem",
                              //     lineHeight: "1rem",
                              //   }}
                              //   title="Streetfolio active"
                              // />
                              "Y"}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_folio_created_on">
                          <td>
                            {user.folio_created_on
                              ? moment(user.folio_created_on).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                              : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_in_folio">
                          <td
                            style={{
                              color: Number(user.in_folio) === 1 ? "#28a745" : "inherit",
                              fontWeight: Number(user.in_folio) === 1 ? "600" : "normal",
                            }}
                          >
                            {Number(user.in_folio) === 1 ? "Interested" : "Not Interested"}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_inv_capital">
                          {/* <td>{user.inv_capital}</td> */}
                          <td>
                            {dropdownOptions.invCapitalList.find(
                              (capital) =>
                                capital.id === parseInt(user.inv_capital)
                            )?.pick_name || user.inv_capital}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_lead_status">
                          {/* <td>{user.lead_status}</td> */}
                          <td>
                            {dropdownOptions.leadStatusList.find(
                              (status) =>
                                status.id === parseInt(user.lead_status)
                            )?.pick_name || user.lead_status}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_exp_in_market">
                          {/* <td>{user.exp_in_market}</td> */}
                          <td>
                            {dropdownOptions.expInMarketList.find(
                              (market) =>
                                market.id === parseInt(user.exp_in_market)
                            )?.pick_name || user.exp_in_market}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_investments">
                          {/* <td>{user.investments}</td> */}
                          <td>
                            {dropdownOptions.investmentsList.find(
                              (investment) =>
                                investment.id === parseInt(user.investments)
                            )?.pick_name || user.investments}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_convertible">
                          {/* <td>{user.convertible}</td> */}
                          <td>
                            {dropdownOptions.convertibleList.find(
                              (convertible) =>
                                convertible.id === parseInt(user.convertible)
                            )?.pick_name || user.convertible}
                          </td>
                        </FieldPermissionWrapper>
                        <td>
                          {user.recent_contacted
                            ? moment(user.recent_contacted).format(
                              "DD-MM-YYYY hh:mm A"
                            )
                            : ""}
                        </td>
                        {/* <FieldPermissionWrapper field="subscriber_next_followup">
                        <td>
                          {user.next_followup
                            ? moment(user.next_followup).format(
                              "DD-MM-YYYY hh:mm A"
                            )
                            : ""}
                        </td>
                      </FieldPermissionWrapper> */}
                        <FieldPermissionWrapper field="subscriber_next_followup">
                          <td>
                            {user.next_followup &&
                              user.next_followup !== "0000-00-00 00:00:00" &&
                              moment(
                                user.next_followup,
                                moment.ISO_8601,
                                true
                              ).isValid() &&
                              moment(user.next_followup).isAfter("1900-01-01")
                              ? moment(user.next_followup).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                              : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_language">
                          {/* <td>{user.language}</td> */}
                          <td>
                            {dropdownOptions.languageList.find(
                              (language) =>
                                language.id === parseInt(user.language)
                            )?.name || user.language}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_client_status">
                          {/* <td>{user.client_status}</td> */}
                          <td>
                            {dropdownOptions.clientStatusList.find(
                              (status) =>
                                status.id === parseInt(user.client_status)
                            )?.pick_name || user.client_status}
                          </td>
                          <td>
                            {user.subscribed_on
                              ? moment(user.subscribed_on).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                              : ""}
                          </td>
                          <td>
                            {user.subscribed_days ? user.subscribed_days : ""}
                          </td>
                          <td>{user.active_days}</td>
                          <td>{user.subscription_amount}</td>
                          <td>{user.first_amount ?? 0}</td>
                        </FieldPermissionWrapper>

                        {/* <FieldPermissionWrapper field="subscriber_status">
                          <td>{user.subscriber_status}</td>
                        </FieldPermissionWrapper> */}
                        <FieldPermissionWrapper field="subscriber_assignedtomenu">
                          {/* <td>{user.assignedto}</td> */}
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={
                              dropdownOptions.assignedUserList.find(
                                (assignedUser) =>
                                  assignedUser.id ===
                                  parseInt(user.assignedto)
                              )?.user_fullname || user.assignedto
                            }
                          >
                            {dropdownOptions.assignedUserList.find(
                              (assignedUser) =>
                                assignedUser.id === parseInt(user.assignedto)
                            )?.user_fullname || user.assignedto}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_assigned_to_research">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.r_assigned}
                          >
                            {user.r_assigned}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_askfps">
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {Number(user.askfps) === 1 ? "Yes" : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_lead_en">
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {Number(user.lead_en) === 1 ? "New" : "Existing"}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_assignedto_folio">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={
                              dropdownOptions.assignedUserList.find(
                                (assignedUser) =>
                                  assignedUser.tu_id ===
                                  parseInt(user.assignedto_folio)
                              )?.tu_user_fullname || user.assignedto_folio
                            }
                          >
                            {dropdownOptions.assignedUserList.find(
                              (assignedUser) =>
                                assignedUser.tu_id ===
                                parseInt(user.assignedto_folio)
                            )?.tu_user_fullname || user.assignedto_folio}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_modified_time">
                          <td>
                            {user.updated_on
                              ? moment(user.updated_on).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                              : ""}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_updatedby">
                          {/* <td>{user.updated_by}</td> */}
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={
                              dropdownOptions.updatedByUserList.find(
                                (updatedUser) =>
                                  updatedUser.id === parseInt(user.updated_by)
                              )?.user_fullname || user.updated_by
                            }
                          >
                            {dropdownOptions.updatedByUserList.find(
                              (updatedUser) =>
                                updatedUser.id === parseInt(user.updated_by)
                            )?.user_fullname || user.updated_by}
                          </td>
                        </FieldPermissionWrapper>
                        <td>{user.deviceid}</td>
                        <FieldPermissionWrapper field="subscriber_utmsource">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.utm_source} // This shows full email on hover
                          >
                            {user.utm_source}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_utmmedium">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.utm_medium}
                          >
                            {user.utm_medium}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_utmcampaign">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.utm_campaign}
                          >
                            {user.utm_campaign}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_utmcontent">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.utm_content}
                          >
                            {user.utm_content}
                          </td>
                        </FieldPermissionWrapper>
                        <FieldPermissionWrapper field="subscriber_utmterm">
                          <td
                            style={{
                              maxWidth: "70px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={user.utm_term}
                          >
                            {user.utm_term}
                          </td>
                        </FieldPermissionWrapper>
                      </tr>
                    );
                  })
                )}
              </tbody>
              <tfoot>
                <FieldPermissionWrapper field="subscriber_subscription_amount">
                <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                  <td
                    colSpan={footerLeadingColSpan}
                    style={{ textAlign: "right", padding: "10px" }}
                  >
                    {showClientStatusColumns && canViewAmountTotals && "Total:"}
                  </td>
                   
                  {showClientStatusColumns && (
                    <>
                      <td style={{ padding: "10px" }}>
                        {canViewAmountTotals &&
                          (loading ? (
                            <span
                              className="skeleton-text"
                              style={{ width: "100px" }}
                            ></span>
                          ) : (
                            parseFloat(totalSubscriptionAmount).toFixed(2)
                          ))}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {canViewAmountTotals &&
                          (loading ? (
                            <span
                              className="skeleton-text"
                              style={{ width: "100px" }}
                            ></span>
                          ) : (
                            parseFloat(totalFirstAmount).toFixed(2)
                          ))}
                      </td>
                    </>
                  )}
                 
                  <td colSpan={footerTrailingColSpan}></td>
                  {/* <FieldPermissionWrapper field="subscriber_subscription_amount">
                    <td style={{ padding: "10px" }}>
                      {parseFloat(totalSubscriptionAmount).toFixed(2)}
                    </td>
                  </FieldPermissionWrapper> */}
                 
                   
                  <td colSpan="10"></td>
                </tr>
                 </FieldPermissionWrapper>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      {/* Backdrop */}
      {(isModalOpenSubscriber ||
        isModalOpenFreeService ||
        isModalOpenStreetStocks ||
        isBulkEditModalOpen ||
        isModalOpenSendPushNotification ||
        isModalOpenSendSms) && (
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 1)",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1040,
            }}
          ></div>
        )}

      {/* Modal structure */}
      {isModalOpenSubscriber && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
            <div className="modal-content">
              <div className="modal-header">
                <div className="col-md-11">
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    Add Subscriber
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={closeModal}
                >
                  &times;
                </button>
                <div className="clearfix"></div>
              </div>
              <div className="modal-body">
                {/* Message Box */}
                {message && (
                  <div
                    className={`col-md-12 alert m-b-10 ${messageType === "success"
                      ? "alert-success"
                      : "alert-danger"
                      }`}
                  >
                    {message}
                  </div>
                )}

                {/* Form */}
                <form
                  onSubmit={handleAddSubscriber}
                  id="addSubscriberForm"
                  className="form-horizontal"
                  encType="multipart/form-data"
                >
                  <input type="hidden" name="from" value="popup" />
                  <div className="panel-body">
                    <div className="row">
                      {/* Full Name */}
                      <div className="col-md-12 mb-2">
                        <label>Name</label>
                        <input
                          type="text"
                          name="fullname"
                          value={formData.fullname}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter Name"
                          required
                        />
                      </div>

                      {/* Mobile Number */}
                      <div className="col-md-12 mb-2">
                        <label>Mobile No.</label>
                        <input
                          type="text"
                          name="mobileno"
                          value={formData.mobileno}
                          onChange={(e) => {
                            // Allow only digits
                            const onlyNums = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            handleInputChange({
                              target: { name: "mobileno", value: onlyNums },
                            });
                            e.target.setCustomValidity(""); // reset message on change
                          }}
                          onInvalid={(e) =>
                            e.target.setCustomValidity(
                              "Please enter a valid 10-digit mobile number"
                            )
                          }
                          pattern="^[0-9]{10}$"
                          maxLength={10}
                          className="form-control"
                          placeholder="Enter Mobile No."
                          required
                        />
                      </div>

                      {/* Email */}
                      <div className="col-md-12 mb-2">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter Email"
                        />
                      </div>

                      {/* Lead Source */}
                      <div className="col-md-12 mb-2">
                        <label>Lead Source</label>
                        <select
                          name="lead_source"
                          value={formData.lead_source}
                          onChange={handleInputChange}
                          className="form-control"
                          required
                        >
                          <option value="">Select Lead Source</option>
                          {dropdownOptions.leadSourceList.map(
                            (option, index) => (
                              <option key={index} value={option.id}>
                                {option.pick_name}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      {/* Language */}
                      <div className="col-md-12 mb-2">
                        <label>Language</label>
                        <select
                          name="language"
                          value={formData.language}
                          onChange={handleInputChange}
                          className="form-control"
                        >
                          <option value="0">Select Language</option>
                          {dropdownOptions.languageList.map((option, index) => (
                            <option key={index} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Action Buttons */}
                      <div className="col-md-12" style={{ textAlign: "right" }}>
                        <button
                          type="submit"
                          className="btn btn-primary mx-2"
                          disabled={isLoading}
                        >
                          {isLoading ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={closeModal}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalOpenFreeService && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" style={{ maxWidth: "30rem" }}>
            <div className="modal-content">
              <div className="modal-header">
                <div className="col-md-11">
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    Add Free Service
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={closeModal}
                >
                  &times;
                </button>
                <div className="clearfix"></div>
              </div>
              <div className="modal-body">
                {/* Message Box */}
                {message && (
                  <div
                    className={`col-md-12 alert m-b-10 ${messageType === "success"
                      ? "alert-success"
                      : "alert-danger"
                      }`}
                  >
                    {message}
                  </div>
                )}

                {/* Form */}
                <form
                  onSubmit={handleAddfreeService}
                  id="addFreeServiceForm"
                  className="form-horizontal"
                  encType="multipart/form-data"
                >
                  <div className="panel-body">
                    <div className="row">
                      {/* Full Name */}
                      <div className="col-md-12 mb-2">
                        <label>Name</label>
                        <input
                          type="text"
                          name="fullname"
                          value={serviceData.fullname}
                          onChange={handleServiceInputChange}
                          className="form-control"
                          placeholder="Enter Name"
                          required
                        />
                      </div>

                      {/* Mobile Number */}
                      <div className="col-md-12 mb-2">
                        <label>Mobile No.</label>
                        <input
                          type="text"
                          name="mobileno"
                          value={serviceData.mobileno}
                          onChange={(e) => {
                            // Allow only digits
                            const onlyNums = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            handleServiceInputChange({
                              target: { name: "mobileno", value: onlyNums },
                            });
                            e.target.setCustomValidity(""); // reset message on change
                          }}
                          onInvalid={(e) =>
                            e.target.setCustomValidity(
                              "Please enter a valid 10-digit mobile number"
                            )
                          }
                          pattern="^[0-9]{10}$"
                          maxLength={10}
                          className="form-control"
                          placeholder="Enter Mobile No."
                          required
                        />
                      </div>

                      {/* Email */}
                      <div className="col-md-12 mb-2">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={serviceData.email}
                          onChange={handleServiceInputChange}
                          className="form-control"
                          placeholder="Enter Email"
                        />
                      </div>

                      {/* Lead Source */}
                      <div className="col-md-12 mb-2">
                        <label>Languages</label>
                        <select
                          name="languageid"
                          value={serviceData.languageid}
                          onChange={handleServiceInputChange}
                          className="form-control"
                          required
                        >
                          <option value="">Select Languages</option>
                          {dropdownOptions.languageList.map((option, index) => (
                            <option key={index} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Service */}
                      <div className="col-md-12 mb-2">
                        <label>Service</label>
                        <select
                          name="serviceid"
                          value={serviceData.serviceid}
                          onChange={handleServiceInputChange}
                          className="form-control"
                          required
                        >
                          <option value="">- Select -</option>
                          {dropdownOptions.serviceList.map((option, index) => (
                            <option key={index} value={option.id}>
                              {option.service_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Total Credits */}
                      <div className="col-md-12 mb-2">
                        <label>Total Credits</label>
                        <input
                          type="number"
                          name="tradesTotal"
                          placeholder="Enter Total Credits"
                          className="form-control"
                          value={serviceData.tradesTotal}
                          onChange={handleServiceInputChange}
                          required
                        />
                      </div>

                      {/* Action Buttons */}
                      <div className="col-md-12" style={{ textAlign: "right" }}>
                        <button
                          type="submit"
                          className="btn btn-primary mx-2"
                          disabled={isLoading}
                        >
                          {isLoading ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={closeModal}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isBulkEditModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="bulkEditModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="col-md-11">
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    Bulk Edit Subscribers (
                    {checkingAll
                      ? `All ${totalCount}`
                      : selectedSubscribers.length}{" "}
                    selected)
                  </h5>
                </div>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => setIsBulkEditModalOpen(false)}
                >
                  &times;
                </button>
                <div className="clearfix"></div>
              </div>
              <div className="modal-body">
                {message && (
                  <div
                    className={`col-md-12 alert m-b-10 ${messageType === "success"
                      ? "alert-success"
                      : "alert-danger"
                      }`}
                  >
                    {message}
                  </div>
                )}

                <form onSubmit={handleBulkEditSubmit} className="form-vertical">
                  <div className="panel-body">
                    <div className="row">
                      <PermissionWrapper
                        module="subscriber_lead_source"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Lead Source</label>
                          <select
                            name="lead_source"
                            value={bulkEditData.lead_source}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.leadSourceList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_state"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Place/ State</label>
                          <select
                            name="state"
                            value={bulkEditData.state}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.stateList?.map((item, index) => (
                              <option key={index} value={item.stateCode}>
                                {item.stateName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_occupation"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Occupation</label>
                          <input
                            name="occupation"
                            placeholder="Occupation"
                            value={bulkEditData.occupation}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          />
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_language"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Language</label>
                          <select
                            name="language"
                            value={bulkEditData.language}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.languageList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.name || item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_exp_in_market"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Experience in Market</label>
                          <select
                            name="exp_in_market"
                            value={bulkEditData.exp_in_market}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.expInMarketList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_inv_capital"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Investment Capital</label>
                          <select
                            name="inv_capital"
                            value={bulkEditData.inv_capital}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.invCapitalList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_risk_level"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Risk Level</label>
                          <select
                            name="risk_level"
                            value={bulkEditData.risk_level}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.riskLevelList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_lead_status"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Lead Status</label>
                          <select
                            name="lead_status"
                            value={bulkEditData.lead_status}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.leadStatusList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_assignedto"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Assign To</label>
                          <select
                            name="assignedto"
                            value={bulkEditData.assignedto}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.assignedUserList?.map(
                              (item, index) => (
                                <option key={index} value={item.tu_id}>
                                  {item.tu_user_fullname}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_reason_not_interested"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Reason Not Interested</label>
                          <select
                            name="reason_not_interested"
                            value={bulkEditData.reason_not_interested}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            {dropdownOptions.reasonNotInterestedList?.map(
                              (item, index) => (
                                <option key={index} value={item.id}>
                                  {item.pick_name}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </PermissionWrapper>

                      <PermissionWrapper
                        module="subscriber_lead_en"
                        action="bulk_edit"
                      >
                        <div className="col-md-6 mb-3">
                          <label>Leads</label>
                          <select
                            name="lead_en"
                            value={bulkEditData.lead_en}
                            onChange={handleBulkEditChange}
                            className="form-control"
                          >
                            <option value="">No Change</option>
                            <option value="0">Existing</option>
                            <option value="1">New</option>
                          </select>
                        </div>
                      </PermissionWrapper>
                    </div>

                    <div className="col-md-12" style={{ textAlign: "right" }}>
                      <button
                        type="submit"
                        className="btn btn-primary mx-2"
                        disabled={isLoading}
                      >
                        {isLoading ? "Updating..." : "Update Subscribers"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        onClick={() => setIsBulkEditModalOpen(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalOpenSendPushNotification && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="col-md-6">
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    Send Push Notification
                  </h5>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-default float-end"
                    onClick={closeModal}
                  >
                    &times;
                  </button>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSendPushNotification}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-label">Title</label>
                        <input
                          type="text"
                          name="title"
                          placeholder="Enter Title"
                          className="form-control"
                          value={sendPushData.title}
                          onChange={handleSendPushInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-label">
                          Select Push Notification Template
                        </label>
                        <select
                          name="pushTemplate"
                          className="form-control"
                          onChange={handleSendPushInputChange}
                          value={sendPushData.pushTemplate}
                        >
                          <option value="">- Select -</option>
                          {dropdownOptions.templatePushNotificationList?.map(
                            (option, index) => (
                              <option key={index} value={option.id}>
                                {option.template_name ||
                                  `Template ${option.id}`}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <fieldset className="form-group">
                        <label className="form-label semibold">Message</label>
                        <textarea
                          name="message"
                          placeholder="Enter Message"
                          className="form-control"
                          value={sendPushData.message}
                          onChange={handleSendPushInputChange}
                        />
                      </fieldset>
                    </div>

                    <div className="col-md-3">
                      <div style={{ float: "left", marginTop: "20px" }}>
                        <button
                          type="submit"
                          name="submit"
                          className="btn btn-primary mx-2"
                        >
                          Submit
                        </button>
                      </div>
                      <div
                        style={{
                          float: "left",
                          marginTop: "20px",
                          marginLeft: "10px",
                        }}
                      >
                        <button
                          type="button"
                          name="cancel"
                          className="btn btn-default"
                          onClick={closeModal} // Close the modal on cancel
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalOpenSendSms && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="col-md-6">
                  <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                    Send SMS
                  </h5>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-default float-end"
                    onClick={closeModal}
                  >
                    &times;
                  </button>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSendSmsSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="control-label">
                          Select SMS Template
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary ml-2"
                            onClick={fetchSmsTemplate}
                            disabled={isLoadingSmsTemplate}
                            title="Refresh Template"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                          </button>
                        </label>
                        {isLoadingSmsTemplate ? (
                          <div
                            className="form-control"
                            style={{ backgroundColor: "#f8f9fa" }}
                          >
                            <i className="fa fa-spinner fa-spin"></i> Loading
                            template...
                          </div>
                        ) : (
                          <select
                            name="pushTemplate"
                            className="form-control"
                            value={sendSmsData.pushTemplate}
                            onChange={handleSendSmsInputChange}
                          >
                            <option value="">-- Select SMS Template --</option>
                            {dropdownOptions.templateSmsList?.map(
                              (template, index) => (
                                <option key={index} value={template.id}>
                                  {template.template_name ||
                                    `Template ${template.id}`}
                                </option>
                              )
                            )}
                          </select>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <fieldset className="form-group">
                        <label className="form-label semibold">Message</label>
                        <textarea
                          name="message"
                          placeholder="Enter Message"
                          className="form-control"
                          value={sendSmsData.message}
                          onChange={handleSendSmsInputChange}
                        />
                      </fieldset>
                    </div>

                    <div className="col-md-3">
                      <div style={{ float: "left", marginTop: "20px" }}>
                        <button
                          type="submit"
                          name="submit"
                          className="btn btn-primary mx-2"
                        >
                          Submit
                        </button>
                      </div>
                      <div
                        style={{
                          float: "left",
                          marginTop: "20px",
                          marginLeft: "10px",
                        }}
                      >
                        <button
                          type="button"
                          name="cancel"
                          className="btn btn-default"
                          onClick={closeModal} // Close the modal on cancel
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpenBulkImport && (
        <>
          <div
            className="modal fade show"
            style={{
              display: "block",
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1050,
            }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="bulkImportModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" style={{ maxWidth: "400px" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <div className="col-md-6">
                    <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                      Bulk Import Data
                    </h5>
                  </div>
                  <div className="col-md-6">
                    <button
                      type="button"
                      className="btn btn-default float-end"
                      onClick={() => setIsModalOpenBulkImport(false)}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="modal-body">
                  <form
                    onSubmit={handleBulkImportSubmit}
                    encType="multipart/form-data"
                  >
                    <div className="form-group mb-3">
                      <label>Import File</label>
                      <input
                        type="file"
                        name="importFile"
                        className="form-control"
                        required
                        accept=".xlsx,.xls,.csv"
                        onChange={(e) => setImportFile(e.target.files[0])}
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary mx-2">
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        onClick={() => setIsModalOpenBulkImport(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1040,
            }}
          ></div>
        </>
      )}

      {isModalOpenSendEmail && (
        <>
          {/* Backdrop */}
          <div className="modal-backdrop fade show"></div>

          {/* Modal */}
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send Bulk Email</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsModalOpenSendEmail(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form
                    onSubmit={handleEmailSubmit}
                    encType="multipart/form-data"
                  >
                    <div className="mb-3">
                      <label>Select Email Template</label>
                      <select
                        className="form-control"
                        value={emailData.emailtemp}
                        onChange={(e) => handleTemplateChange(e.target.value)}
                      >
                        <option value="">-- Select Template --</option>
                        {templateList.map((tpl) => (
                          <option key={tpl.id} value={tpl.id}>
                            {tpl.templatename}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label>Subject</label>
                      <input
                        type="text"
                        className="form-control"
                        value={emailData.subject}
                        onChange={(e) =>
                          setEmailData((prev) => ({
                            ...prev,
                            subject: e.target.value,
                          }))
                        }
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label>Message</label>
                      <ReactQuill
                        theme="snow"
                        value={emailData.message}
                        onChange={(value) =>
                          setEmailData((prev) => ({ ...prev, message: value }))
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label>Upload File</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) =>
                          setEmailData({
                            ...emailData,
                            file: e.target.files[0],
                          })
                        }
                      />
                    </div>

                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary me-2">
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setIsModalOpenSendEmail(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {isCampaignModalOpen && (
        <CampaignModal
          isOpen={isCampaignModalOpen}
          onClose={() => setIsCampaignModalOpen(false)}
          templateList={templateList}
          onSubmit={handleCampaignSubmit}
          loading={campaignLoading}
          selectedCount={checkingAll ? totalCount : selectedSubscribers.length}
          checkingAll={checkingAll}
        />
      )}
      {isAICampaignModalOpen && (
        <AICampaignModal
          isOpen={isAICampaignModalOpen}
          onClose={() => setIsAICampaignModalOpen(false)}
          selectedLeads={filteredUsers.filter((u) =>
            selectedSubscribers.includes(u.id)
          )}
          selectedCount={checkingAll ? totalCount : selectedSubscribers.length}
          onSuccess={() => {
            fetchUsers(page);
            setSelectedSubscribers([]);
          }}
        />
      )}
      {isSarvamCampaignModalOpen && (
        <SarvamCampaignModal
          isOpen={isSarvamCampaignModalOpen}
          onClose={() => setIsSarvamCampaignModalOpen(false)}
          selectedLeads={filteredUsers.filter((u) =>
            selectedSubscribers.includes(u.id)
          )}
          selectedCount={checkingAll ? totalCount : selectedSubscribers.length}
          onSuccess={() => {
            fetchUsers(page);
            setSelectedSubscribers([]);
          }}
        />
      )}
      {/* {isAiVoiceCallModalOpen && (
        <AIVoiceCallModal
          isOpen={isAiVoiceCallModalOpen}
          onClose={() => {
            setIsAiVoiceCallModalOpen(false);
            setSelectedSubscriberForAiCall(null);
          }}
          subscriber={selectedSubscriberForAiCall}
        />
      )} */}

      {isCampaignExportOpen && (
        <CampaignExportModal
          isOpen={isCampaignExportOpen}
          onClose={() => setIsCampaignExportOpen(false)}
          onSubmit={handleCampaignExport}
          loading={loading}
          checkingAll={checkingAll}
          selectedCount={checkingAll ? totalCount : selectedSubscribers.length}
        />
      )}
      {isBroadcastModalOpen && (
        <BroadcastModal
          isOpen={isBroadcastModalOpen}
          onClose={() => setIsBroadcastModalOpen(false)}
          onSubmit={handleBroadcastSubmit}
          // loading={broadcastLoading}
          loading={loading}
          selectedCount={checkingAll ? totalCount : selectedSubscribers.length}
          checkingAll={checkingAll}
        />
      )}
    </div>
  );
};

export default Subscriber;
